<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <div class="text-center">
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64" @click="overlay = false"></v-progress-circular>
          </v-overlay>
        </div>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense>
        <p style="font-size:30px; color: white;" class="mb-0">Empresas</p>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="d-flex justify-end">
        <v-btn-toggle class="mb-0 pb-0" center>
          <v-btn @click="registro=true">Registro</v-btn>
          <v-btn @click="registro=false">Listado</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" v-if="registro">
        <v-card mx-auto outlined>
          <v-row dense class="ma-3">
            <v-col cols="12" md="12" sm="12" xs="12" lg="8" xl="8">
              <v-autocomplete
                v-model="idempresa"
                :items="empresas"
                :search-input.sync="searchempresa"
                flat
                outlined
                dense
                clearable
                prepend-inner-icon="mdi-magnify"
                hide-no-data
                hide-details
                label="Buscar empresa..."
                solo-inverted
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="12" sm="12" xs="12" lg="4" xl="4" class="d-flex justify-end">
              <v-btn-toggle>
                <v-btn @click="editItem">Consultar</v-btn>
                <v-btn @click="limpiar">Nuevo</v-btn>
              </v-btn-toggle>
            </v-col>
            <!-- Informacion personal -->
            
            <v-col cols="12" md="12" sm="12" xs="12" class="pt-5" dense>
              <span class="font-weight-bold primary--text">Datos generales</span>
              <v-alert
                v-if="mensaje"
                :type="tipoMensaje"
                dense
                outlined
              >
                {{ mensaje }}
              </v-alert>
              <v-row dense>
                <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" v-if="mostrarInfo">
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <v-card outlined class="pa-3 d-flex align-center">
                        <v-icon
                          :color="estadoColor"
                          large
                          class="mr-3"
                        >
                          mdi-circle
                        </v-icon>
                        <div class="font-weight-medium">
                          {{localia_representante}}
                        </div>
                      </v-card>
                    </v-col>

                    <!-- CATEGORÍA -->
                    <v-col cols="12" md="4">
                      <v-card outlined class="pa-4 text-center">
                        <span class="font-weight-bold">
                          {{categoria_proveedor}}
                        </span>
                      </v-card>
                    </v-col>

                    <!-- CÓDIGO -->
                    <v-col cols="12" md="4">
                      <v-card outlined class="pa-4 text-center">
                        <span class="font-weight-bold">
                          CÓDIGO: {{ usuarios_concatenados }}
                        </span>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6">
                  <v-row dense>
                    <!-- <v-text-field
                      v-model="fecha_presentacion"
                      label="Fecha de Presentación"
                      dense
                      @click:append="menuFecha = true"
                      append-icon="mdi-calendar"
                    ></v-text-field>

                    <v-menu
                      v-model="menuFecha"
                      :close-on-content-click="false"
                      offset-y
                    >
                      <v-date-picker
                        v-model="fecha_presentacion"
                        @input="menuFecha = false"
                      ></v-date-picker>
                    </v-menu> -->
                    <v-text-field
                      v-model="fecha_presentacion"
                      label="Fecha de Presentación"
                      class="pt-0"
                      outlined
                      dense
                      prepend-inner-icon="mdi-calendar"
                      type="date"
                      max-width="43"
                      :rules="[
                        () =>
                          !!fecha_presentacion ||
                          'Campo requerido',
                      ]"
                      :error-messages="errorMessages"
                      ref="fecha_presentacion"
                      required
                      @change="generarFechaInicio1"
                    ></v-text-field>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-text-field
                        v-model="razonsocial"
                        label="Razón Social del Proveedor"
                        outlined
                        dense
                        class="pt-0"
                        :rules="[() => !!razonsocial || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="razonsocial"
                        prepend-inner-icon="mdi-domain"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="ruc"
                        label="RUC del Proveedor"
                        outlined
                        dense
                        prepend-inner-icon="mdi-card-account-details"
                        :rules="[() => !!ruc || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="ruc"
                        v-mask="'###########'"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-text-field v-model="sector" label="SUNAT Actividad(es) Económica(s):" dense outlined prepend-inner-icon="mdi-office-building" class="pt-0" ref="sector" :rules="[() => !!sector || 'Campo requerido']" required></v-text-field>
                    </v-col>
                    <!--<v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field v-model="especialidad" label="Especialidad" dense class="pt-0"></v-text-field>
                    </v-col> -->
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <v-text-field
                        v-model="representante_cel"
                        label="Celular"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-phone"
                        :rules="[() => !!representante_cel || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="representante_cel"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <v-text-field
                        v-model="correo"
                        label="Correo Electrónico"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-email"
                        :rules="[() => !!correo || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="correo"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="nombre_comercial"
                        label="Nombre Comercial"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-store"
                        :rules="[() => !!nombre_comercial || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="nombre_comercial"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-textarea
                        v-model="carta_presentacion"
                        label="Rubro Carta de Presentación"
                        class="pt-0"
                        outlined
                        dense
                        auto-grow
                        rows="2"
                        counter
                        prepend-inner-icon="mdi-file-document"
                        :rules="[() => !!carta_presentacion || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="carta_presentacion"
                        required
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-select
                        :items="rubro_tipo_s"
                        item-value="id"
                        item-text="nombrecategoria"
                        v-model="rubro_tipo_servicio"
                        label="Rubro Principal"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-store"
                        :rules="[() => !!rubro_tipo_servicio || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="rubro_tipo_servicio"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <v-text-field
                        v-model="mesa_trabajo"
                        label="Mesa de trabajo"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-table-chair"
                        :rules="[() => !!mesa_trabajo || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="mesa_trabajo"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="6" xl="6" dense class="pt-0">
                      <v-select
                        :items="diag_ccia"
                        v-model="diagnostico_ccia"
                        label="Contacto con CCIA"
                        class="pt-0"
                        outlined
                        dense
                        clearable
                        prepend-inner-icon="mdi-clipboard-text"
                        ref="diagnostico_ccia"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-text-field
                        v-model="direccion_declarada"
                        label="Dirección Declarada"
                        outlined
                        dense
                        prepend-inner-icon="mdi-map-marker"
                        class="pt-0"
                        :rules="[() => !!direccion_declarada || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="direccion_declarada"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-text-field
                        v-model="departamento"
                        label="Departamento"
                        outlined
                        dense
                        prepend-inner-icon="mdi-map"
                        class="pt-0"
                        :rules="[() => !!departamento || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="departamento"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-text-field
                        v-model="provincia"
                        label="Provincia"
                        outlined
                        dense
                        prepend-inner-icon="mdi-map-outline"
                        class="pt-0"
                        :rules="[() => !!provincia || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="provincia"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-text-field
                        v-model="distrito"
                        label="Distrito"
                        outlined
                        dense
                        prepend-inner-icon="mdi-map-marker-radius"
                        class="pt-0"
                        :rules="[() => !!distrito || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="distrito"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-row dense>
                        <!-- <v-text-field
                          v-model="fecha_inicio_ruc"
                          label="Fecha de Inicio de Actividades Según Ficha RUC"
                          dense
                          @click:append="menuFechaRUC = true"
                          append-icon="mdi-calendar"
                        ></v-text-field>
                        <v-menu
                          v-model="menuFechaRUC"
                          :close-on-content-click="false"
                          offset-y
                        >
                          <v-date-picker
                            v-model="fecha_inicio_ruc"
                            @input="menuFechaRUC = false"
                          ></v-date-picker>
                        </v-menu> -->
                        <v-text-field
                          v-model="fecha_inicio_ruc"
                          label="Fecha de Inicio de Actividades Según Ficha RUC"
                          class="pt-0"
                          outlined
                          dense
                          prepend-inner-icon="mdi-calendar"
                          type="date"
                          max-width="43"
                          :rules="[
                            () =>
                              !!fecha_inicio_ruc ||
                              'Campo requerido',
                          ]"
                          :error-messages="errorMessages"
                          ref="fecha_inicio_ruc"
                          required
                          @change="generarFechaInicio3"
                        ></v-text-field>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-text-field
                        v-model="puntaje_antiguedad"
                        label="Puntaje de Antigüedad de Operaciones"
                        outlined
                        dense
                        prepend-inner-icon="mdi-star"
                        class="pt-0"
                        ref="puntaje_antiguedad"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-text-field
                        v-model="representante"
                        label="Representante Legal"
                        outlined
                        dense
                        prepend-inner-icon="mdi-account-tie"
                        class="pt-0"
                        :rules="[() => !!representante || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="representante"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model.number="porcentaje_pro"
                        label="Porcentaje de propiedad del representante Legal"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-percent"
                        suffix="%"
                        :rules="[() => !!porcentaje_pro || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="porcentaje_pro"
                        type="number"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-divider class="mx-4" vertical></v-divider>
                <v-col cols="12" md="12" sm="12" xs="12" lg="5" xl="5">
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="representante_dni"
                        outlined
                        dense
                        prepend-inner-icon="mdi-card-account-details-outline"
                        class="pt-0"
                        label="DNI REPRESENTANTE LEGAL"
                        :rules="[() => !!representante_dni || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="representante_dni"
                        v-mask="'########'"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <!-- <v-text-field
                        v-model="fecha_emi_dni"
                        label="Fecha de Emision (DNI)"
                        dense
                        @click:append="menuFechaEmi = true"
                        append-icon="mdi-calendar"
                      ></v-text-field>

                      <v-menu
                        v-model="menuFechaEmi"
                        :close-on-content-click="false"
                        offset-y
                      >
                        <v-date-picker
                          v-model="fecha_emi_dni"
                          @input="menuFechaEmi = false"
                        ></v-date-picker>
                      </v-menu> -->
                      <v-text-field
                      v-model="fecha_emi_dni"
                      label="Fecha de Emision (DNI)"
                      class="pt-0"
                      outlined
                      dense
                      prepend-inner-icon="mdi-calendar-check"
                      type="date"
                      max-width="43"
                      :rules="[
                        () =>
                          !!fecha_emi_dni ||
                          'Campo requerido',
                      ]"
                      :error-messages="errorMessages"
                      ref="fecha_emi_dni"
                      required
                      @change="generarFechaInicio2"
                    ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="ubigeo_nacimiento"
                        label="Ubigeo de Nacimiento"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-map-marker-account"
                        :rules="[() => !!ubigeo_nacimiento || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="ubigeo_nacimiento"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="lugar_nacimiento"
                        label="Lugar de Nacimiento Distrito"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-map-marker"
                        ref="lugar_nacimiento"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="influencia_dni"
                        label="Área de Influencia de Nacimiento"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-radar"
                        ref="influencia_dni"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="residencia"
                        label="Residencia Actual Distrito"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-home-map-marker"
                        :rules="[() => !!residencia || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="residencia"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="influencia_residencia"
                        label="Área de Influencia Residencia Actual"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-radar"
                        ref="influencia_residencia"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="puntaje_residencia"
                        label="Puntaje de Antigüedad de Residencia Actual"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-star"
                        ref="puntaje_residencia"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="localia_representante"
                        label="Localía Según Representante Legal"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-map-check"
                        ref="localia_representante"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="puntaje_localia"
                        label="Puntaje de Localía Representante Legal"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-star-check"
                        ref="puntaje_localia"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="domicilio_fiscal"
                        label="Domicilio Fiscal Distrito"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-home-city"
                        ref="domicilio_fiscal"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="area_influencia_ruc"
                        label="Área de Influencia Domicilio Fiscal"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-radar"
                        ref="area_influencia_ruc"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="puntaje_localia_dom"
                        label="Puntaje de Localía Domicilio Fiscal"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-star"
                        ref="puntaje_localia_dom"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="resultado_final_localia"
                        label="Resultado Final de Localía"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-check-decagram"
                        ref="resultado_final_localia"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="puntaje_total_localia"
                        label="Puntaje Total de Localía"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-trophy"
                        ref="puntaje_total_localia"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-textarea
                        v-model="comentario"
                        label="Comentarios / Documentación Pendiente"
                        class="pt-0"
                        outlined
                        dense
                        auto-grow
                        rows="2"
                        counter
                        prepend-inner-icon="mdi-note-text"
                        :rules="[() => !!comentario || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="comentario"
                        required
                      ></v-textarea>
                    </v-col>
                     <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-select
                        :items="consorciado_fo"
                        v-model="empresa_foranea"
                        label="Consorciado con Empresa Foránea"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-handshake"
                        ref="empresa_foranea"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                      <v-text-field
                        v-model="categoria_proveedor"
                        label="Categorización de Proveedor"
                        class="pt-0"
                        outlined
                        dense
                        prepend-inner-icon="mdi-shield-star"
                        ref="categoria_proveedor"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-text-field
                        v-model="correo_cobertura"
                        label="Correo Cobertura de Servicio"
                        outlined
                        dense
                        prepend-inner-icon="mdi-email"
                        class="pt-0"
                        :rules="[() => !!correo_cobertura || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="correo_cobertura"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-text-field
                        v-model="respuesta_cobertura"
                        label="Respuesta Cobertura de Servicio"
                        outlined
                        dense
                        prepend-inner-icon="mdi-reply"
                        class="pt-0"
                        :rules="[() => !!respuesta_cobertura || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="respuesta_cobertura"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-5">
                      <v-text-field
                        v-model="comentario_cobertura"
                        label="Comentario Cobertura de Servicio"
                        outlined
                        dense
                        prepend-inner-icon="mdi-comment-text"
                        class="pt-0"
                        :rules="[() => !!comentario_cobertura || 'Campo requerido']"
                        :error-messages="errorMessages"
                        ref="comentario_cobertura"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                  <v-row dense>
                    <v-col cols="7" md="7" sm="12" xs="12" dense>
                      <span class="font-weight-bold primary--text">Rubros (Tipos de servicio)</span>
                    </v-col>
                    <v-col cols="4" md="4" sm="12" xs="12" dense class="d-flex justify-end">
                      <v-btn
                        class="ma-2"
                        small
                        outlined
                        fab
                        color="primary"
                        @click.stop="abrirDialogRubros"
                        :disabled="nuevodetalle"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                      <v-dialog v-model="dialogrubros" max-width="400px">
                        <v-card outlined class="pa-2">
                          <v-row dense>
                            <v-col
                              cols="12"
                              md="12"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0 d-flex justify-center"
                            >
                              <span class="font-weight-bold mb-2 justify-center"
                                >Formulario</span
                              >
                            </v-col>
                          </v-row>
                          <v-divider></v-divider>
                          <v-card-text dense class="mt-4">
                            <v-row dense>
                              <v-col
                                cols="12"
                                md="12"
                                sm="12"
                                xs="12"
                                dense
                                class="pt-0"
                              >
                                <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                                  <!-- <v-text-field
                                    v-model="cantidad"
                                    label="Rubro (Tipo de servicio)"
                                    dense
                                    class="pt-0"
                                    :rules="[
                                      () => !!cantidad || 'Campo requerido',
                                    ]"
                                    :error-messages="errorMessages"
                                    ref="cantidad"
                                    required
                                  ></v-text-field> -->
                                  <v-select
                                    :items="rubro_tipo_ss"
                                    item-value="id"
                                    item-text="nombrecategoria"
                                    v-model="rubro_tipo_servicio_di"
                                    label="Rubro (Tipo de Servicio)"
                                    class="pt-0"
                                    prepend-inner-icon="mdi-briefcase"
                                    outlined
                                    dense
                                    :rules="[() => !!rubro_tipo_servicio_di || 'Campo requerido']"
                                    :error-messages="errorMessages"
                                    ref="rubro_tipo_servicio_di"
                                    required
                                  ></v-select>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" dense class="pt-0">
                                  <v-text-field
                                    v-model="especialidad"
                                    label="Especialidad"
                                    dense
                                    prepend-inner-icon="mdi-tools"
                                    outlined
                                    class="pt-0"
                                    :rules="[
                                      () => !!especialidad || 'Campo requerido',
                                    ]"
                                    :error-messages="errorMessages"
                                    ref="especialidad"
                                    required
                                  ></v-text-field>
                                </v-col>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-row dense>
                            <v-col
                              cols="12"
                              md="12"
                              sm="12"
                              xs="12"
                              dense
                              class="pt-0 d-flex justify-center"
                            >
                              <v-btn
                                class="ma-2"
                                color="primary"
                                :disabled="overlay2"
                                @click="agregarRubro"
                                >Guardar</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-dialog>
                    </v-col>
                  </v-row>
                  <v-col cols="12" md="12" sm="12" xs="12" dense>
                    <v-data-table
                      :headers="headerrubros"
                      :items="lista_rubros"
                      hide-default-footer
                      class="elevation-1"
                      dense
                    >
                      <template v-slot:item.actions="{ item }">
                        <v-icon
                          color="primary"
                          class="pr-1"
                          @click="editItemDetalle(item)"
                          >mdi-square-edit-outline</v-icon
                        >
                        <v-icon @click="deleteItemRubro(item)" color="primary"
                          >mdi-delete</v-icon
                        >
                      </template>
                      <template v-slot:item.resumen="{ item }">
                        <v-list-item three-line>
                          <v-list-item-content>
                            <v-list-item-title>{{item.especialidad}}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                      <template v-slot:no-data
                        >No tiene registrada información sobre los detalles.</template
                      >
                      <template v-slot:no-results>NO RESULTS HERE!</template>
                    </v-data-table>
                  </v-col>
                </v-col>
                <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                  <!-- <v-card
                    outlined
                    class="ma-3 pa-3"
                    v-if="tieneAlimentacion">
                    <span class="font-weight-bold primary--text">Cocina / Planta</span>

                    <v-text-field v-model="cocinaplanta.direccioncocinaplanta" label="dirección de la cocina / planta" dense outlined prepend-inner-icon="mdi-map-marker"/>

                    <v-checkbox v-model="cocinaplanta.coberturacocachacra" label="cobertura cocachacra" />
                    <v-checkbox v-model="cocinaplanta.coberturadeanvaldivia" label="cobertura deán valdivia" />
                    <v-checkbox v-model="cocinaplanta.coberturapuntabombon" label="cobertura punta de bombón" />
                    <v-checkbox v-model="cocinaplanta.coberturamejia" label="cobertura mejía" />
                    <v-checkbox v-model="cocinaplanta.coberturamollendo" label="cobertura mollendo" />
                    <v-text-field v-model="cocinaplanta.coberturaotros" label="otros" dense outlined prepend-inner-icon="mdi-map-marker"/>

                    <v-checkbox v-model="cocinaplanta.servicioraciones" label="raciones" />
                    <v-checkbox v-model="cocinaplanta.serviciobuffet" label="buffet" />
                    <v-checkbox v-model="cocinaplanta.serviciocafeteria" label="cafetería" />
                    <v-checkbox v-model="cocinaplanta.serviciocatering" label="catering" />

                    <v-text-field v-model.number="cocinaplanta.capacidaddiaria" label="capacidad diaria" type="number" dense outlined prepend-inner-icon="mdi-counter"/>

                    <v-switch v-model="cocinaplanta.certificadosanitariovigente" label="certificado sanitario vigente" />
                    <v-switch v-model="cocinaplanta.vehiculosrefrigerados" label="vehículos refrigerados" />
                    <v-switch v-model="cocinaplanta.capacidadinstalarcomedor" label="instalar comedor en campo" />

                    <v-text-field v-model.number="cocinaplanta.propuestaeconomica" label="propuesta económica (s/.)" type="number" dense outlined prepend-inner-icon="mdi-currency-usd"/>
                  </v-card> -->
                  <v-card outlined class="ma-3 pa-3" v-if="tieneAlimentacion">

                    <v-row align="center">
                      <v-col cols="6">
                        <span class="font-weight-bold primary--text">Cocina / Planta</span>
                      </v-col>

                      <v-col cols="6" class="text-right">
                        <v-btn color="primary" small @click="dialogCocina = true">
                          <v-icon left>mdi-plus</v-icon>
                          agregar
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-divider class="my-2"></v-divider>

                    <!-- TABLA -->
                    <v-data-table
                      :headers="headerCocina"
                      :items="lista_cocinaplanta"
                      dense
                      hide-default-footer
                    >

                      <template v-slot:item.actions="{ item, index }">
                        <v-icon small color="primary" @click="editarCocina(item, index)">
                          mdi-square-edit-outline
                        </v-icon>

                        <v-icon small color="red" @click="eliminarCocina(index)">
                          mdi-delete
                        </v-icon>
                      </template>

                      <template v-slot:no-data>
                        no hay cocina / planta registrada
                      </template>

                    </v-data-table>


                    <!-- DIALOG -->
                    <v-dialog v-model="dialogCocina" max-width="700px">
                      <v-card outlined class="pa-3">

                        <span class="font-weight-bold">registro de cocina / planta</span>

                        <v-divider class="my-2"></v-divider>

                        <v-row dense>

                          <v-col cols="12">
                            <v-text-field
                              v-model="cocinaplanta.direccioncocinaplanta"
                              label="dirección de la cocina / planta"
                              dense
                              outlined
                              prepend-inner-icon="mdi-map-marker"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-checkbox v-model="cocinaplanta.coberturacocachacra" label="cocachacra" />
                          </v-col>

                          <v-col cols="6">
                            <v-checkbox v-model="cocinaplanta.coberturadeanvaldivia" label="deán valdivia" />
                          </v-col>

                          <v-col cols="6">
                            <v-checkbox v-model="cocinaplanta.coberturapuntabombon" label="punta de bombón" />
                          </v-col>

                          <v-col cols="6">
                            <v-checkbox v-model="cocinaplanta.coberturamejia" label="mejía" />
                          </v-col>

                          <v-col cols="6">
                            <v-checkbox v-model="cocinaplanta.coberturamollendo" label="mollendo" />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="cocinaplanta.coberturaotros"
                              label="otros"
                              dense
                              outlined
                              prepend-inner-icon="mdi-map-marker-radius"
                            />
                          </v-col>

                          <v-col cols="3">
                            <v-checkbox v-model="cocinaplanta.servicioraciones" label="raciones" />
                          </v-col>

                          <v-col cols="3">
                            <v-checkbox v-model="cocinaplanta.serviciobuffet" label="buffet" />
                          </v-col>

                          <v-col cols="3">
                            <v-checkbox v-model="cocinaplanta.serviciocafeteria" label="cafetería" />
                          </v-col>

                          <v-col cols="3">
                            <v-checkbox v-model="cocinaplanta.serviciocatering" label="catering" />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="cocinaplanta.capacidaddiaria"
                              label="capacidad diaria"
                              type="number"
                              dense
                              outlined
                              prepend-inner-icon="mdi-counter"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="cocinaplanta.propuestaeconomica"
                              label="propuesta económica (s/.)"
                              type="number"
                              dense
                              outlined
                              prepend-inner-icon="mdi-cash"
                            />
                          </v-col>

                          <v-col cols="4">
                            <v-switch
                              v-model="cocinaplanta.certificadosanitariovigente"
                              label="certificado sanitario"
                            />
                          </v-col>

                          <v-col cols="4">
                            <v-switch
                              v-model="cocinaplanta.vehiculosrefrigerados"
                              label="vehículos refrigerados"
                            />
                          </v-col>

                          <v-col cols="4">
                            <v-switch
                              v-model="cocinaplanta.capacidadinstalarcomedor"
                              label="instalar comedor en campo"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-text-field
                              v-model="cocinaplanta.enlace"
                              label="enlace"
                              dense
                              outlined
                              prepend-inner-icon="mdi-link"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="cocinaplanta.tipo_servicio"
                              label="tipo de servicio"
                              dense
                              outlined
                              prepend-inner-icon="mdi-food"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="cocinaplanta.cantidad_sillas"
                              label="cantidad de sillas"
                              type="number"
                              dense
                              outlined
                              prepend-inner-icon="mdi-seat"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-text-field
                              v-model="cocinaplanta.comentarios"
                              label="comentarios"
                              dense
                              outlined
                              prepend-inner-icon="mdi-comment-text-outline"
                            />
                          </v-col>

                        </v-row>

                        <v-divider class="my-2"></v-divider>

                        <v-row dense justify="center">

                          <v-btn color="primary" @click="guardarCocina">
                            guardar
                          </v-btn>

                        </v-row>

                      </v-card>
                    </v-dialog>

                  </v-card>

                  <!-- <v-card
                    outlined
                    class="ma-3 pa-3"
                    v-if="tieneAlojamiento">
                    <span class="font-weight-bold primary--text">Hospedaje</span>
        
                    <v-text-field v-model.number="hospedaje.habitacionesindividuales" label="habitaciones individuales" type="number" dense outlined prepend-inner-icon="mdi-bed"/>
                    <v-text-field v-model.number="hospedaje.habitacionesdobles" label="habitaciones dobles" type="number" dense outlined prepend-inner-icon="mdi-bed"/>
                    <v-text-field v-model.number="hospedaje.habitacionesmultiples" label="habitaciones múltiples" type="number" dense outlined prepend-inner-icon="mdi-bed"/>

                    <v-text-field v-model.number="hospedaje.capacidadtotalcamas" label="capacidad total camas" type="number" dense outlined prepend-inner-icon="mdi-bed-king"/>

                    <v-checkbox v-model="hospedaje.serviciodesayuno" label="desayuno" />
                    <v-checkbox v-model="hospedaje.serviciowifi" label="wifi" />
                    <v-checkbox v-model="hospedaje.serviciolavanderia" label="lavandería" />
                    <v-checkbox v-model="hospedaje.servicioestacionamiento" label="estacionamiento" />
                    <v-checkbox v-model="hospedaje.servicioaguacaliente" label="agua caliente" />

                    <v-switch v-model="hospedaje.certificadoitsevigente" label="certificado itse vigente" />

                    <v-text-field v-model.number="hospedaje.tarifacorporativareferencial" label="tarifa corporativa (s/.)" type="number" dense outlined prepend-inner-icon="mdi-cash"/>
                  </v-card> -->
                  <v-card outlined class="ma-3 pa-3" v-if="tieneAlojamiento">

                    <v-row align="center">
                      <v-col cols="6">
                        <span class="font-weight-bold primary--text">Hospedaje</span>
                      </v-col>

                      <v-col cols="6" class="text-right">
                        <v-btn color="primary" small @click="dialogHospedaje=true">
                          <v-icon left>mdi-plus</v-icon>
                          agregar
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-divider class="my-2"></v-divider>

                    <!-- TABLA -->
                    <v-data-table
                      :headers="headerHospedaje"
                      :items="lista_hospedaje"
                      dense
                      hide-default-footer
                    >

                      <template v-slot:item.actions="{ item, index }">
                        <v-icon small color="primary" @click="editarHospedaje(item,index)">
                          mdi-square-edit-outline
                        </v-icon>

                        <v-icon small color="red" @click="eliminarHospedaje(index)">
                          mdi-delete
                        </v-icon>
                      </template>

                      <template v-slot:no-data>
                        no hay hospedajes registrados
                      </template>

                    </v-data-table>


                    <!-- DIALOG -->
                    <v-dialog v-model="dialogHospedaje" max-width="700px">
                      <v-card outlined class="pa-3">

                        <span class="font-weight-bold">registro de hospedaje</span>

                        <v-divider class="my-2"></v-divider>

                        <v-row dense>

                          <v-col cols="12">
                            <v-text-field
                              v-model="hospedaje.nombre_establecimiento"
                              label="nombre del establecimiento"
                              dense outlined
                              prepend-inner-icon="mdi-home-city"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-text-field
                              v-model="hospedaje.direccion_establecimiento"
                              label="dirección"
                              dense outlined
                              prepend-inner-icon="mdi-map-marker"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="hospedaje.distrito_ubicacion"
                              label="distrito"
                              dense outlined
                              prepend-inner-icon="mdi-map"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="hospedaje.enlace"
                              label="enlace"
                              dense outlined
                              prepend-inner-icon="mdi-link"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="hospedaje.tipo_habitacion"
                              label="tipo de habitación"
                              dense outlined
                              prepend-inner-icon="mdi-bed"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="hospedaje.cantidad_habitaciones"
                              label="cantidad habitaciones"
                              type="number"
                              dense outlined
                              prepend-inner-icon="mdi-door"
                            />
                          </v-col>

                          <v-col cols="4">
                            <v-text-field
                              v-model.number="hospedaje.habitacionesindividuales"
                              label="habitaciones individuales"
                              type="number"
                              dense outlined
                              prepend-inner-icon="mdi-bed"
                            />
                          </v-col>

                          <v-col cols="4">
                            <v-text-field
                              v-model.number="hospedaje.habitacionesdobles"
                              label="habitaciones dobles"
                              type="number"
                              dense outlined
                              prepend-inner-icon="mdi-bed"
                            />
                          </v-col>

                          <v-col cols="4">
                            <v-text-field
                              v-model.number="hospedaje.habitacionesmultiples"
                              label="habitaciones múltiples"
                              type="number"
                              dense outlined
                              prepend-inner-icon="mdi-bed"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-text-field
                              v-model.number="hospedaje.capacidadtotalcamas"
                              label="capacidad total camas"
                              type="number"
                              dense outlined
                              prepend-inner-icon="mdi-bed-king"
                            />
                          </v-col>

                          <v-col cols="4">
                            <v-checkbox v-model="hospedaje.serviciodesayuno" label="desayuno"/>
                          </v-col>

                          <v-col cols="4">
                            <v-checkbox v-model="hospedaje.serviciowifi" label="wifi"/>
                          </v-col>

                          <v-col cols="4">
                            <v-checkbox v-model="hospedaje.serviciolavanderia" label="lavandería"/>
                          </v-col>

                          <v-col cols="4">
                            <v-checkbox v-model="hospedaje.servicioestacionamiento" label="estacionamiento"/>
                          </v-col>

                          <v-col cols="4">
                            <v-checkbox v-model="hospedaje.servicioaguacaliente" label="agua caliente"/>
                          </v-col>

                          <v-col cols="4">
                            <v-switch v-model="hospedaje.certificadoitsevigente" label="certificado itse"/>
                          </v-col>

                          <v-col cols="12">
                            <v-text-field
                              v-model.number="hospedaje.tarifacorporativareferencial"
                              label="tarifa corporativa (s/.)"
                              type="number"
                              dense outlined
                              prepend-inner-icon="mdi-cash"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-textarea
                              v-model="hospedaje.comentarios"
                              label="comentarios"
                              rows="2"
                              dense outlined
                              prepend-inner-icon="mdi-comment-text-outline"
                            />
                          </v-col>

                        </v-row>

                        <v-divider class="my-2"></v-divider>

                        <v-row dense justify="center">
                          <v-btn color="primary" @click="guardarHospedaje">
                            guardar
                          </v-btn>
                        </v-row>

                      </v-card>
                    </v-dialog>

                  </v-card>

                  <!-- <v-card
                    outlined
                    class="ma-3 pa-3"
                    v-if="tieneTransporte">
                    <span class="font-weight-bold primary--text">Garaje / Base de operaciones</span>

                    <v-text-field v-model="garaje.direcciongarajebase" label="dirección" dense outlined prepend-inner-icon="mdi-garage" />
                    <v-checkbox v-model="garaje.coberturacocachacra" label="cocachacra" />
                    <v-checkbox v-model="garaje.coberturadeanvaldivia" label="deán valdivia" />
                    <v-checkbox v-model="garaje.coberturapuntabombon" label="punta de bombón" />
                    <v-checkbox v-model="garaje.coberturamejia" label="mejía" />
                    <v-checkbox v-model="garaje.coberturamollendo" label="mollendo"/>
                    <v-checkbox v-model="garaje.cob_rutas_regionales" label="rutas regionales"/>
                    <v-text-field v-model="garaje.coberturaotros" label="otros" dense outlined prepend-inner-icon="mdi-road-variant" />
                  </v-card> -->

                  <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12" v-if="tieneTransporte">
                    <v-col cols="12" dense>
                      <v-row dense>
                        <v-col cols="8">
                          <span class="font-weight-bold primary--text">Flota Vehicular</span>
                        </v-col>

                        <v-col cols="4" class="d-flex justify-end">
                          <v-btn
                            small
                            outlined
                            fab
                            color="primary"
                            @click="dialogFlota = true"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>

                      <!-- dialog -->
                      <v-dialog v-model="dialogFlota" max-width="600px">
                        <v-card outlined class="pa-3">
                          <span class="font-weight-bold">registro de flota</span>
                          <v-divider class="my-2" />

                          <v-row dense>
                            <v-col cols="12">
                              <v-text-field v-model="flota.tipounidad" label="tipo de unidad" dense outlined prepend-inner-icon="mdi-bus"/>
                            </v-col>

                            <v-col cols="6">
                              <v-text-field v-model="flota.placa" label="placa" dense outlined prepend-inner-icon="mdi-card-text"/>
                            </v-col>

                            <v-col cols="6">
                              <v-text-field v-model="flota.marca" label="marca" dense outlined prepend-inner-icon="mdi-car"/>
                            </v-col>

                            <v-col cols="6">
                              <v-text-field v-model="flota.modelo" label="modelo" dense outlined prepend-inner-icon="mdi-car-info" />
                            </v-col>

                            <v-col cols="6">
                              <v-text-field v-model.number="flota.anio" label="año" type="number" dense outlined prepend-inner-icon="mdi-calendar"/>
                            </v-col>

                            <v-col cols="6">
                              <v-text-field v-model="flota.capacidad" label="capacidad" dense outlined prepend-inner-icon="mdi-account-multiple"/>
                            </v-col>

                            <v-col cols="4">
                              <v-switch v-model="flota.soatpolizavigente" label="soat" prepend-inner-icon="mdi-shield-check" />
                            </v-col>

                            <v-col cols="4">
                              <v-switch v-model="flota.gps" label="gps" prepend-inner-icon="mdi-crosshairs-gps"/>
                            </v-col>

                            <v-col cols="4">
                              <v-switch v-model="flota.cinturon3puntos" label="cinturón 3 puntos" prepend-inner-icon="mdi-seatbelt"/>
                            </v-col>

                            <v-col cols="12">
                              <v-text-field v-model="flota.tarifareferencial" label="tarifa referencial" dense outlined prepend-inner-icon="mdi-cash"/>
                            </v-col>

                            <v-col cols="12">
                              <v-text-field 
                                v-model="flota.comentarios" 
                                label="Comentarios" 
                                dense 
                                outlined 
                                prepend-inner-icon="mdi-comment-text-outline"
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-text-field 
                                v-model="flota.clasificacion" 
                                label="Clasificación" 
                                dense 
                                outlined 
                                prepend-inner-icon="mdi-format-list-bulleted"
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-text-field 
                                v-model="flota.otros" 
                                label="Otros" 
                                dense 
                                outlined 
                                prepend-inner-icon="mdi-dots-horizontal"
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-text-field 
                                v-model="flota.propio_alquilado" 
                                label="Propio / Alquilado" 
                                dense 
                                outlined 
                                prepend-inner-icon="mdi-car-key"
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-switch v-model="flota.i_operador" label="Incluye Operador" prepend-inner-icon="mdi-account-hard-hat"/>
                            </v-col>

                            <v-col cols="12">
                              <v-switch v-model="flota.i_combustible" label="Incluye Combustible" prepend-inner-icon="mdi-gas-station"/>
                            </v-col>
                          </v-row>

                          <v-divider class="my-2" />

                          <v-row dense justify="center">
                            <v-btn color="primary" @click="guardarFlota">
                              guardar
                            </v-btn>
                          </v-row>
                        </v-card>
                      </v-dialog>
                    </v-col>
                    <v-data-table
                      :headers="headerFlota"
                      :items="lista_flota"
                      dense
                      hide-default-footer
                    >
                      <template v-slot:item.actions="{ item, index }">
                        <v-icon small color="primary" @click="editarFlota(item, index)">
                          mdi-square-edit-outline
                        </v-icon>
                        <v-icon small color="red" @click="eliminarFlota(index)">
                          mdi-delete
                        </v-icon>
                      </template>

                      <template v-slot:no-data>
                        no hay flota registrada
                      </template>
                    </v-data-table>
                  </v-col>

                  <!-- <v-card
                    outlined
                    class="ma-3 pa-3"
                    v-if="tieneMaquinaria">
                    <span class="font-weight-bold primary--text">Ubicación de equipo</span>

                    <v-text-field v-model="ubicacionequipo.ubicacionequipogaraje" label="ubicación" dense outlined prepend-inner-icon="mdi-garage"/>

                    <v-checkbox v-model="ubicacionequipo.coberturacocachacra" label="cocachacra" />
                    <v-checkbox v-model="ubicacionequipo.coberturadeanvaldivia" label="deán valdivia" />
                    <v-checkbox v-model="ubicacionequipo.coberturapuntabombon" label="punta de bombón" />
                    <v-checkbox v-model="ubicacionequipo.coberturamejia" label="mejía" />
                    <v-checkbox v-model="ubicacionequipo.coberturamollendo" label="mollendo" />
                    <v-text-field v-model="ubicacionequipo.coberturaotros" label="otros" dense outlined prepend-inner-icon="mdi-road-variant"/>
                  </v-card> -->

                  <v-col cols="12" dense v-if="tieneMaquinaria">
                    <v-row dense>
                      <v-col cols="8">
                        <span class="font-weight-bold primary--text">Maquinaria</span>
                      </v-col>

                      <v-col cols="4" class="d-flex justify-end">
                        <v-btn
                          small
                          outlined
                          fab
                          color="primary"
                          @click="dialogMaquinaria = true"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-dialog v-model="dialogMaquinaria" max-width="650px">
                      <v-card outlined class="pa-3">
                        <v-row dense>
                          <v-col cols="12" class="d-flex justify-center">
                            <span class="font-weight-bold">registro de maquinaria</span>
                          </v-col>
                        </v-row>

                        <v-divider class="my-2" />

                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field
                              v-model="maquinaria.tipomaquinaria"
                              label="tipo de maquinaria"
                              dense
                              outlined prepend-inner-icon="mdi-excavator"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="maquinaria.marcamodelo"
                              label="marca / modelo"
                              dense
                              outlined prepend-inner-icon="mdi-cog"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="maquinaria.anio"
                              label="año"
                              type="number"
                              dense
                              outlined prepend-inner-icon="mdi-calendar"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-text-field
                              v-model="maquinaria.capacidadtecnica"
                              label="capacidad técnica (m³ / ton)"
                              dense
                              outlined prepend-inner-icon="mdi-weight"
                            />
                          </v-col>

                          <v-col cols="4">
                            <v-switch
                              v-model="maquinaria.certificadosvigentes"
                              label="certificados vigentes"
                            />
                          </v-col>

                          <v-col cols="4">
                            <v-switch
                              v-model="maquinaria.incluyeoperador"
                              label="incluye operador"
                            />
                          </v-col>

                          <v-col cols="4">
                            <v-switch
                              v-model="maquinaria.incluyecombustible"
                              label="incluye combustible"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-text-field
                              v-model="maquinaria.tipotarifa"
                              label="Tipo de Tarifa"
                              dense
                              outlined prepend-inner-icon="mdi-tag"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-text-field
                              v-model="maquinaria.tarifareferencial"
                              label="tarifa referencial (s/. hora / día)"
                              dense
                              outlined prepend-inner-icon="mdi-cash"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="maquinaria.categoria_maquinaria"
                              label="categoría maquinaria"
                              dense
                              outlined
                              prepend-inner-icon="mdi-cog"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="maquinaria.ubicacion_actual"
                              label="ubicación actual"
                              dense
                              outlined
                              prepend-inner-icon="mdi-map-marker"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="maquinaria.dias_movilizacion"
                              label="días movilización"
                              type="number"
                              dense
                              outlined
                              prepend-inner-icon="mdi-calendar-clock"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="maquinaria.otros"
                              label="otros"
                              dense
                              outlined
                              prepend-inner-icon="mdi-dots-horizontal"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-switch
                              v-model="maquinaria.propio_alquilado"
                              label="propio / alquilado"
                              prepend-inner-icon="mdi-truck"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-switch
                              v-model="maquinaria.tarifa_inc_movilizacion"
                              label="tarifa incluye movilización"
                              prepend-inner-icon="mdi-cash-plus"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-textarea
                              v-model="maquinaria.comentarios"
                              label="comentarios"
                              rows="2"
                              dense
                              outlined
                              prepend-inner-icon="mdi-comment-text-outline"
                            />
                          </v-col>
                        </v-row>

                        <v-divider class="my-2" />

                        <v-row dense justify="center">
                          <v-btn color="primary" @click="guardarMaquinaria">
                            guardar
                          </v-btn>
                        </v-row>
                      </v-card>
                    </v-dialog>
                    <v-col cols="12" dense>
                      <v-data-table
                        :headers="headerMaquinaria"
                        :items="lista_maquinaria"
                        dense
                        hide-default-footer
                      >
                        <template v-slot:item.actions="{ item, index }">
                          <v-icon
                            small
                            color="primary"
                            class="mr-1"
                            @click="editarMaquinaria(item, index)"
                          >
                            mdi-square-edit-outline
                          </v-icon>

                          <v-icon
                            small
                            color="red"
                            @click="eliminarMaquinaria(index)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>

                        <template v-slot:no-data>
                          no tiene maquinaria registrada
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-col>

                  <v-col cols="12" dense v-if="tieneCombustible">

                    <v-row dense>
                      <v-col cols="8">
                        <span class="font-weight-bold primary--text">Planta / Grifo</span>
                      </v-col>

                      <v-col cols="4" class="d-flex justify-end">
                        <v-btn
                          small
                          outlined
                          fab
                          color="primary"
                          @click="dialogPlantagrifo = true"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>


                    <!-- DIALOG -->

                    <v-dialog v-model="dialogPlantagrifo" max-width="650px">

                      <v-card outlined class="pa-3">

                        <v-row dense>
                          <v-col cols="12" class="d-flex justify-center">
                            <span class="font-weight-bold">registro planta / grifo</span>
                          </v-col>
                        </v-row>

                        <v-divider class="my-2"/>

                        <v-row dense>

                          <v-col cols="6">
                            <v-text-field
                              v-model="plantagrifo.tipo_suministro"
                              label="tipo de suministro"
                              dense
                              outlined
                              prepend-inner-icon="mdi-fuel"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="plantagrifo.producto"
                              label="producto"
                              dense
                              outlined
                              prepend-inner-icon="mdi-barrel"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-text-field
                              v-model="plantagrifo.enlace"
                              label="enlace"
                              dense
                              outlined
                              prepend-inner-icon="mdi-link"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-textarea
                              v-model="plantagrifo.descripcion"
                              label="descripción"
                              dense
                              outlined
                              rows="2"
                              prepend-inner-icon="mdi-text"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-textarea
                              v-model="plantagrifo.especificacion"
                              label="especificación"
                              dense
                              outlined
                              rows="2"
                              prepend-inner-icon="mdi-clipboard-text"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="plantagrifo.capacidad_almacenamiento"
                              label="capacidad almacenamiento"
                              type="number"
                              dense
                              outlined
                              prepend-inner-icon="mdi-database"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="plantagrifo.distritos_cobertura"
                              label="distritos cobertura"
                              dense
                              outlined
                              prepend-inner-icon="mdi-map-marker-multiple"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="plantagrifo.capacidadsuministrodiario"
                              label="capacidad diaria (gal)"
                              type="number"
                              dense
                              outlined
                              prepend-inner-icon="mdi-counter"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="plantagrifo.capacidadcisternas"
                              label="capacidad cisterna (gal)"
                              type="number"
                              dense
                              outlined
                              prepend-inner-icon="mdi-barrel"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-switch
                              v-model="plantagrifo.permisososinergminvigentes"
                              label="permisos osinergmin vigentes"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="plantagrifo.tiempominimopreaviso"
                              label="tiempo mínimo preaviso (horas)"
                              type="number"
                              dense
                              outlined
                              prepend-inner-icon="mdi-timer"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="plantagrifo.tarifareferencial"
                              label="tarifa referencial"
                              type="number"
                              dense
                              outlined
                              prepend-inner-icon="mdi-cash"
                            />
                          </v-col>

                        </v-row>

                        <v-divider class="my-2"/>

                        <v-row dense justify="center">
                          <v-btn color="primary" @click="guardarPlantagrifo">
                            guardar
                          </v-btn>
                        </v-row>

                      </v-card>

                    </v-dialog>


                    <!-- TABLA -->

                    <v-col cols="12" dense>

                      <v-data-table
                        :headers="headerPlantagrifo"
                        :items="lista_plantagrifo"
                        dense
                        hide-default-footer
                      >

                        <template v-slot:item.actions="{ item, index }">

                          <v-icon
                            small
                            color="primary"
                            class="mr-1"
                            @click="editarPlantagrifo(item, index)"
                          >
                            mdi-square-edit-outline
                          </v-icon>

                          <v-icon
                            small
                            color="red"
                            @click="eliminarPlantagrifo(index)"
                          >
                            mdi-delete
                          </v-icon>

                        </template>

                        <template v-slot:no-data>
                          no tiene planta / grifo registrado
                        </template>

                      </v-data-table>

                    </v-col>

                  </v-col>

                  <v-col cols="12" dense v-if="tieneOtrosBienes">

                    <v-row dense>
                      <v-col cols="8">
                        <span class="font-weight-bold primary--text">Otros Bienes</span>
                      </v-col>

                      <v-col cols="4" class="d-flex justify-end">
                        <v-btn
                          small
                          outlined
                          fab
                          color="primary"
                          @click="dialogOtrosBienes = true"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>


                    <!-- DIALOG -->

                    <v-dialog v-model="dialogOtrosBienes" max-width="650px">

                      <v-card outlined class="pa-3">

                        <v-row dense>
                          <v-col cols="12" class="d-flex justify-center">
                            <span class="font-weight-bold">registro otros bienes</span>
                          </v-col>
                        </v-row>

                        <v-divider class="my-2"/>

                        <v-row dense>

                          <v-col cols="6">
                            <v-text-field
                              v-model="otrosbienes.categoria_bien"
                              label="categoría del bien"
                              dense
                              outlined
                              prepend-inner-icon="mdi-shape"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="otrosbienes.certificacion_producto"
                              label="certificación del producto"
                              dense
                              outlined
                              prepend-inner-icon="mdi-certificate"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-textarea
                              v-model="otrosbienes.descripcion_especifica"
                              label="descripción específica"
                              dense
                              outlined
                              rows="2"
                              prepend-inner-icon="mdi-text"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="otrosbienes.capacidad_suministro_mensual"
                              label="capacidad suministro mensual"
                              dense
                              outlined
                              prepend-inner-icon="mdi-chart-bar"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="otrosbienes.ubicacion_almacen"
                              label="ubicación del almacén"
                              dense
                              outlined
                              prepend-inner-icon="mdi-warehouse"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="otrosbienes.tiempo_entrega_dias"
                              label="tiempo entrega (días)"
                              type="number"
                              dense
                              outlined
                              prepend-inner-icon="mdi-calendar-clock"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="otrosbienes.tarifareferencial"
                              label="tarifa referencial"
                              dense
                              outlined
                              prepend-inner-icon="mdi-cash"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-switch
                              v-model="otrosbienes.bien_propio"
                              label="bien propio"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-switch
                              v-model="otrosbienes.bien_alquilado"
                              label="bien alquilado"
                            />
                          </v-col>

                        </v-row>

                        <v-divider class="my-2"/>

                        <v-row dense justify="center">
                          <v-btn color="primary" @click="guardarOtrosBienes">
                            guardar
                          </v-btn>
                        </v-row>

                      </v-card>

                    </v-dialog>


                    <!-- TABLA -->

                    <v-col cols="12" dense>

                      <v-data-table
                        :headers="headerOtrosBienes"
                        :items="lista_otrosbienes"
                        dense
                        hide-default-footer
                      >

                        <template v-slot:item.bien_propio="{ item }">
                          <v-icon v-if="item.bien_propio" color="green">
                            mdi-check
                          </v-icon>
                        </template>

                        <template v-slot:item.bien_alquilado="{ item }">
                          <v-icon v-if="item.bien_alquilado" color="orange">
                            mdi-check
                          </v-icon>
                        </template>

                        <template v-slot:item.actions="{ item, index }">

                          <v-icon
                            small
                            color="primary"
                            class="mr-1"
                            @click="editarOtrosBienes(item, index)"
                          >
                            mdi-square-edit-outline
                          </v-icon>

                          <v-icon
                            small
                            color="red"
                            @click="eliminarOtrosBienes(index)"
                          >
                            mdi-delete
                          </v-icon>

                        </template>

                        <template v-slot:no-data>
                          no tiene otros bienes registrados
                        </template>

                      </v-data-table>

                    </v-col>

                  </v-col>

                  <v-col cols="12" dense v-if="tieneOtrosServicios">

                    <v-row dense>
                      <v-col cols="8">
                        <span class="font-weight-bold primary--text">Otros Servicios</span>
                      </v-col>

                      <v-col cols="4" class="d-flex justify-end">
                        <v-btn
                          small
                          outlined
                          fab
                          color="primary"
                          @click="dialogOtrosServicios = true"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>


                    <!-- DIALOG -->

                    <v-dialog v-model="dialogOtrosServicios" max-width="700px">

                      <v-card outlined class="pa-3">

                        <v-row dense>
                          <v-col cols="12" class="d-flex justify-center">
                            <span class="font-weight-bold">registro de otros servicios</span>
                          </v-col>
                        </v-row>

                        <v-divider class="my-2"/>

                        <v-row dense>

                          <v-col cols="6">
                            <v-text-field
                              v-model="otrosservicios.categoria_servicio"
                              label="categoría del servicio"
                              dense
                              outlined
                              prepend-inner-icon="mdi-briefcase"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model="otrosservicios.tiempo_respuesta"
                              label="tiempo de respuesta"
                              dense
                              outlined
                              prepend-inner-icon="mdi-timer"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-textarea
                              v-model="otrosservicios.descripcion_servicio"
                              label="descripción del servicio"
                              dense
                              outlined
                              rows="2"
                              prepend-inner-icon="mdi-text"
                            />
                          </v-col>

                          <v-col cols="4">
                            <v-switch
                              v-model="otrosservicios.equipamiento_propio"
                              label="equipamiento propio"
                            />
                          </v-col>

                          <v-col cols="4">
                            <v-switch
                              v-model="otrosservicios.personal_especializado"
                              label="personal especializado"
                            />
                          </v-col>

                          <v-col cols="4">
                            <v-switch
                              v-model="otrosservicios.atiende_campamento"
                              label="atiende campamento"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-text-field
                              v-model="otrosservicios.certificaciones"
                              label="certificaciones"
                              dense
                              outlined
                              prepend-inner-icon="mdi-certificate"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-textarea
                              v-model="otrosservicios.experiencia_relevante"
                              label="experiencia relevante"
                              dense
                              outlined
                              rows="2"
                              prepend-inner-icon="mdi-star-outline"
                            />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field
                              v-model.number="otrosservicios.tarifareferencial"
                              label="tarifa referencial"
                              dense
                              outlined
                              prepend-inner-icon="mdi-cash"
                            />
                          </v-col>

                        </v-row>

                        <v-divider class="my-2"/>

                        <v-row dense justify="center">
                          <v-btn color="primary" @click="guardarOtrosServicios">
                            guardar
                          </v-btn>
                        </v-row>

                      </v-card>

                    </v-dialog>


                    <!-- TABLA -->

                    <v-col cols="12" dense>

                      <v-data-table
                        :headers="headersOtrosServicios"
                        :items="lista_otrosservicios"
                        dense
                        hide-default-footer
                      >

                        <template v-slot:item.equipamiento_propio="{ item }">
                          <v-icon v-if="item.equipamiento_propio" color="green">
                            mdi-check
                          </v-icon>
                        </template>

                        <template v-slot:item.personal_especializado="{ item }">
                          <v-icon v-if="item.personal_especializado" color="green">
                            mdi-check
                          </v-icon>
                        </template>

                        <template v-slot:item.atiende_campamento="{ item }">
                          <v-icon v-if="item.atiende_campamento" color="green">
                            mdi-check
                          </v-icon>
                        </template>

                        <template v-slot:item.actions="{ item, index }">

                          <v-icon
                            small
                            color="primary"
                            class="mr-1"
                            @click="editarOtrosServicios(item, index)"
                          >
                            mdi-square-edit-outline
                          </v-icon>

                          <v-icon
                            small
                            color="red"
                            @click="eliminarOtrosServicios(index)"
                          >
                            mdi-delete
                          </v-icon>

                        </template>

                        <template v-slot:no-data>
                          no tiene otros servicios registrados
                        </template>

                      </v-data-table>

                    </v-col>

                  </v-col>
                </v-col>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn color="primary" class="mb-5" @click="save" :disabled="overlay2">Guardar</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="12" sm="12" xs="12" dense v-else>
        <v-card class="mx-auto" outlined>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="empresa_headers"
                :items="empresa_item"
                :search="searchempresas"
                sort-by="razonsocial"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title class=".body-2">Empresa</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-dialog v-model="adModal" max-width="290px">
                      <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">
                          <span class=".font-weight-thin">¿Activar item?</span>
                        </v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">
                          <span class=".font-weight-thin">¿Desactivar item?</span>
                        </v-card-title>
                        <v-card-text>
                          Estas a punto de
                          <span v-if="adAccion==1">activar</span>
                          <span v-if="adAccion==2">desactivar</span>
                          el item asoaciado a
                          <strong>{{adNombre}}</strong>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            outlined
                            @click="ActivarDesactivarCerrar()"
                          >Cancelar</v-btn>
                          <v-btn
                            v-if="adAccion==1"
                            color="blue darken-1"
                            outlined
                            text
                            @click="Activar()"
                          >Activar</v-btn>
                          <v-btn
                            v-if="adAccion==2"
                            color="blue darken-1"
                            outlined
                            text
                            @click="Desactivar()"
                          >Desactivar</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchempresas"
                      append-icon="mdi-magnify"
                      label="Busqueda"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                  <v-divider></v-divider>
                  <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                    <input type="file" @change="seleccionarArchivo" accept=".xlsx,.xls" :disabled="loading" />
                    <v-btn color="primary" class="mb-5" @click="importarExcel" :disabled="loading"><span v-if="!loading">Importar Excel</span><span v-else>Importando...</span></v-btn>
                    <v-overlay :value="loading">
                      <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                  </v-col>
                  <v-col cols="12" md="12" sm="12" xs="12" lg="12" xl="12">
                    <v-file-input
                      label="Subir Excel Alimentación"
                      accept=".xlsx"
                      @change="subirExcel"
                    />
                  </v-col>
                </template>
                <!-- Template para condicion -->
                <template v-slot:item.condicion="{ item }">
                  <v-switch v-model="item.condicion" inset @change="ActivarDesactivar(item)"></v-switch>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="primary"
                    class="mr-5"
                    @click="editItemEmpresa(item)"
                  >mdi-square-edit-outline</v-icon>
                </template>
                <template v-slot:no-data></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="color">
        <v-icon dark class="pr-5">{{icon}}</v-icon>
        {{error}}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
//Importamos Axios
import axios from "axios";
//Nuestro codigo Vue
const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  }
})
export default {
  data() {
    return {
      //Ayuda
      registro: true,
      nuevo: true,
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      overlay: false,
      overlay2: false,
      snackbar: false,
      error: null,
      errorMessages: "",
      form1HasErrors: false,
      form2HasErrors: false,
      color: "#2A3B4D",
      icon: "mdi-thumb-up",
      dialogcontratosempresas: false,
      pattern: '/[A-Z]/\\W',
      fecha_presentacion: null,
      menuFecha: false,
      fecha_inicio_ruc: null,
      menuFechaRUC: false,
      puntaje_antiguedad: 0,
      menuFechaEmi: false,
      rubro_tipo_servicio: "",
      rubro_tipo_servicio_di: "",
      especialidad: "",
      nombre_comercial: "",
      carta_presentacion: "",
      diagnostico_ccia: "",
      direccion_declarada: "",
      departamento: "",
      provincia: "",
      distrito: "",
      influencia_residencia: "",
      puntaje_residencia: 0,
      localia_representante: "",
      puntaje_localia: "",
      puntaje_localia_dom: "",
      resultado_final_localia: "",
      puntaje_total_localia: "",
      empresa_foranea: "",
      categoria_proveedor: "",
      usuarios_concatenados: "",
      correo_cobertura: "",
      respuesta_cobertura: "",
      comentario_cobertura: "",
      rubro_tipo_s: [],
      rubro_tipo_ss: [],
      dialogrubros: false,
      nuevodetalle: false,
      lista_detalles: [],
      lista_rubros: [],
      especialidad: "",
      dialogFlota: false,
      dialogMaquinaria: false,
      archivo: null,
      estado: 'pendiente', // aprobado | pendiente | rechazado
      codigo: 'FASE 2',
      mostrarInfo: false,
      rubros: {
        transporte: 1,
        maquinaria: 2,
        combustible: 8,
        alojamiento: 10,
        alimentacion: 11 ,
        otrosservicios: 5,
      },
      cocinaplanta: {
        direccioncocinaplanta: '',
        coberturacocachacra: false,
        coberturadeanvaldivia: false,
        coberturapuntabombon: false,
        coberturamejia: false,
        coberturamollendo: false,
        coberturaotros: '',
        servicioraciones: false,
        serviciobuffet: false,
        serviciocafeteria: false,
        serviciocatering: false,
        capacidaddiaria: null,
        certificadosanitariovigente: false,
        vehiculosrefrigerados: false,
        capacidadinstalarcomedor: false,
        propuestaeconomica: null,
        enlace:'',
        tipo_servicio:'',
        cantidad_sillas:null,
        comentarios:'',
      },
      dialogCocina:false,

      lista_cocinaplanta:[],

      cocinaplanta:{},

      headerCocina:[
       { text:"Dirección", value:"direccioncocinaplanta"},
       { text:"Capacidad", value:"capacidaddiaria"},
       { text:"Propuesta", value:"propuestaeconomica"},
       { text:"Raciones", value:"servicioraciones"},
       { text:"Buffet", value:"serviciobuffet"},
       { text:"Cafetería", value:"serviciocafeteria"},
       { text:"Catering", value:"serviciocatering"},
       { text:"Acciones", value:"actions", sortable:false}
      ],

      hospedaje: {
        habitacionesindividuales: null,
        habitacionesdobles: null,
        habitacionesmultiples: null,
        capacidadtotalcamas: null,
        serviciodesayuno: false,
        serviciowifi: false,
        serviciolavanderia: false,
        servicioestacionamiento: false,
        servicioaguacaliente: false,
        certificadoitsevigente: false,
        tarifacorporativareferencial: null,
        nombre_establecimiento: null,
        direccion_establecimiento: null,
        enlace: null,
        distrito_ubicacion: null,
        tipo_habitacion: null,
        cantidad_habitaciones: null,
        comentarios: null,
      },
      dialogHospedaje:false,

      lista_hospedaje:[],
      headerHospedaje:[
       {text:"Establecimiento", value:"nombre_establecimiento"},
       {text:"Distrito", value:"distrito_ubicacion"},
       {text:"Tipo habitación", value:"tipo_habitacion"},
       {text:"Cantidad", value:"cantidad_habitaciones"},
       {text:"Capacidad camas", value:"capacidadtotalcamas"},
       {text:"Tarifa", value:"tarifacorporativareferencial"},
       {text:"Acciones", value:"actions", sortable:false}
      ],

      garaje: {
        direcciongarajebase: '',
        coberturacocachacra: false,
        coberturadeanvaldivia: false,
        coberturapuntabombon: false,
        coberturamejia: false,
        coberturamollendo: false,
        coberturaotros: '',
        fecharegistro: new Date().toISOString().slice(0, 10)
      },

      flota: {
        tipounidad: '',
        placa: '',
        marca: '',
        modelo: '',
        anio: null,
        capacidad: '',
        soatpolizavigente: false,
        gps: false,
        cinturon3puntos: false,
        tarifareferencial: '',
        comentarios: '',
        clasificacion: '',
        otros: '',
        i_operador: false,
        i_combustible: false,
        propio_alquilado: '',
      },

      lista_flota: [],

      headerFlota: [
        { text: 'tipo', value: 'tipounidad' },
        { text: 'placa', value: 'placa' },
        { text: 'marca', value: 'marca' },
        { text: 'año', value: 'anio' },
        { text: 'acciones', value: 'actions', sortable: false }
      ],
      indexFlotaEdit: null,

      ubicacionequipo: {
        ubicacionequipogaraje: '',
        coberturacocachacra: false,
        coberturadeanvaldivia: false,
        coberturapuntabombon: false,
        coberturamejia: false,
        coberturamollendo: false,
        coberturaotros: ''
      },

      maquinaria: {
        tipomaquinaria: '',
        marcamodelo: '',
        anio: null,
        capacidadtecnica: '',
        certificadosvigentes: false,
        incluyeoperador: false,
        incluyecombustible: false,
        tipotarifa: '',
        tarifareferencial: '',
        categoria_maquinaria:'',
        otros:'',
        ubicacion_actual:'',
        dias_movilizacion:null,
        propio_alquilado:false,
        tarifa_inc_movilizacion:false,
        comentarios:''
      },

      lista_maquinaria: [],

      headerMaquinaria: [
        { text: 'tipo', value: 'tipomaquinaria' },
        { text: 'marca / modelo', value: 'marcamodelo' },
        { text: 'año', value: 'anio' },
        { text: 'capacidad', value: 'capacidadtecnica' },
        { text: 'acciones', value: 'actions', sortable: false }
      ],

      indexMaquinariaEdit: null,

      dialogPlantagrifo: false,
      indexPlantagrifoEdit: null,
      lista_plantagrifo: [],

      headerPlantagrifo: [

      { text: "Tipo suministro", value: "tipo_suministro" },
      { text: "Producto", value: "producto" },
      { text: "Cap. almacenamiento", value: "capacidad_almacenamiento" },
      { text: "Distritos", value: "distritos_cobertura" },
      { text: "Cap. diaria", value: "capacidadsuministrodiario" },
      { text: "Tarifa", value: "tarifareferencial" },
      { text: "Acciones", value: "actions", sortable:false }

      ],

      plantagrifo: {
        tipo_suministro: "",
        enlace: "",
        producto: "",
        descripcion: "",
        especificacion: "",
        capacidad_almacenamiento: null,
        distritos_cobertura: "",
        capacidadsuministrodiario: null,
        capacidadcisternas: null,
        permisososinergminvigentes: false,
        tiempominimopreaviso: null,
        tarifareferencial: null
      },

      dialogOtrosBienes: false,
      indexOtrosBienesEdit: null,

      otrosbienes: {
        categoria_bien: "",
        descripcion_especifica: "",
        certificacion_producto: "",
        capacidad_suministro_mensual: "",
        ubicacion_almacen: "",
        tiempo_entrega_dias: null,
        bien_propio: false,
        bien_alquilado: false,
        tarifareferencial: null
      },

      lista_otrosbienes: [],

      headerOtrosBienes: [

      { text: "Categoría", value: "categoria_bien" },
      { text: "Certificación", value: "certificacion_producto" },
      { text: "Capacidad mensual", value: "capacidad_suministro_mensual" },
      { text: "Ubicación", value: "ubicacion_almacen" },
      { text: "Entrega (días)", value: "tiempo_entrega_dias" },
      { text: "Tarifa", value: "tarifareferencial" },
      { text: "Propio", value: "bien_propio" },
      { text: "Alquilado", value: "bien_alquilado" },
      { text: "Acciones", value: "actions", sortable:false }

      ],

      dialogOtrosServicios: false,
      indexOtrosServiciosEdit: null,

      otrosservicios: {
        categoria_servicio: "",
        descripcion_servicio: "",
        equipamiento_propio: false,
        personal_especializado: false,
        atiende_campamento: false,
        tiempo_respuesta: "",
        certificaciones: "",
        experiencia_relevante: "",
        tarifareferencial: null
      },

      lista_otrosservicios: [],

      headersOtrosServicios: [

        { text: "Categoría", value: "categoria_servicio" },
        { text: "Descripción", value: "descripcion_servicio" },
        { text: "Equipamiento", value: "equipamiento_propio" },
        { text: "Personal", value: "personal_especializado" },
        { text: "Campamento", value: "atiende_campamento" },
        { text: "Tiempo respuesta", value: "tiempo_respuesta" },
        { text: "Certificaciones", value: "certificaciones" },
        { text: "Experiencia", value: "experiencia_relevante" },
        { text: "Tarifa", value: "tarifareferencial" },
        { text: "Acciones", value: "actions", sortable: false }

      ],

      headerrubros: [
      // { text: "Tipo de Servicio", value: "rubro_tipo_servicio_di", align: "start" },
      { text: "Tipo de Servicio", value: "rubro_tipo_servicio_nombre" },
      { text: "Especialidad", value: "especialidad", align: "start" },
      { text: "Opciones", value: "actions", sortable: false, align: "end" }],

      //Tablas
      empresa_headers: [
        { text: "Razón Social del Proveedor", value: "razonsocial" },
        { text: "Nombre Comercial", value: "nombre_comercial" },
        { text: "RUC del Proveedor", value: "ruc" },
        // { text: "Rubro", value: "tipo_empresa" },
        { text: "Representante Legal", value: "representante" },
        { text: "Celular", value: "representante_cel" },
        { text: "Correo Electrónico", value: "correo" },
        { text: "Categorización de Proveedor", value: "categoria_proveedor" },
        { text: "Resultado Final de Localía", value: "resultado_final_localia"},
      ],
      empresa_item: [],
      
      /*Empresa */
      tipo_empresas: [
        { text: "Principal", value: "PRINCIPAL" },
        { text: "Contratista", value: "CONTRATISTA" },
      ],
      tipos_locacion: [
        { text: "Local", value: "LOCAL" },
        { text: "Foraneo", value: "FORANEO" },
      ],
      llocaciones: [
        { text: "Local", value: 1 },
        { text: "Foraneo", value: 2 },
      ],
      diag_ccia: [
        { text: "SI", value: true },
        { text: "NO", value: false },
      ],
      consorciado_fo: [
        { text: "SI", value: true },
        { text: "NO", value: false },
      ],
      boletas: [
        { text: "SI", value: true },
        { text: "NO", value: false },
      ],
      facturas: [
        { text: "SI", value: true },
        { text: "NO", value: false },
      ],
      detalle: "",
      cantidad: "",
      searchempresa: "",
      searchempresas: "",
      editedIndex: -1,
      idempresa: "",
      ruc: "",
      razonsocial: "",
      abreviatura: "",
      nombrecompleto: "",
      tipo_empresa: "",
      tipo_locacion: "",
      llocacion: "",
      idlocacion: "",
      licencia: false,
      boleta: false,
      factura: false,
      sector: "",
      representante: "",
      representante_dni: "",
      representante_cel: "",
      primer_contacto: "",
      segundo_contacto: "",
      giro_comercial: "",
      pro_ser_principal: "",
      pro_ser_secundario: "",
      numero_licencia: "",
      locacion: "",
      descripcion: "",
      empresas: [],
      direccion_fiscal: "",
      anexos: "",
      mesa_trabajo: "",
      sede: "",
      correo: "",
      servicio1: "",
      servicio2: "",
      servicio3: "",
      servicio4: "",
      servicio5: "",
      servicio6: "",
      ubigeo_nacimiento: "",
      lugar_nacimiento: "",
      residencia: "",
      domicilio_fiscal: "",
      influencia_dni: "",
      fecha_emi_dni: "",
      pendiente: "",
      comentario: "",
      porcentaje_pro: "",
      diagnostico: "",
      porcentaje: "",
      grado_madurez: "",
      porcentaje_avance: "",
      area_influencia_ruc: "",
      localia: "",
      observacion: "",
      indexCocinaPlantaEdit: null,
      indexHospedajeEdit: null,
      indexGarajeEdit: null,
      indexFlotaEdit: null,
      indexUbicacionEquipoEdit: null,
      indexMaquinariaEdit: null,
      indexPlantaGrifoEdit: null,
      /*contratosempresas*/
      contratosempresasconflictivos: [
        { text: "SI", value: true },
        { text: "NO", value: false },
      ],
      searchareas: "",
      editedIndexContratosEmpresas: -1,
      contratosempresasid: "",
      contratosempresasname: "",
      contratosempresasabreviatura: "",
      contratosempresasdescripcion: "",
      contratosempresasfecha_inicio: "",
      contratosempresasfecha_fin: "",
      contratosempresasconflictivo: "",
      contratosempresasobservaciones: "",
      contratosempresasmonto_contrato: "",
      contratosempresasservicio_calidad: "",
      contratosempresasservicio_observaciones: "",
      contadorcontratos: 0,
      contratosempresass: [],
      CheckListaRubros: false,
      headercontratosempresas: [
        { text: "Contratos", value: "resumen", align: "start" },
        { text: "Actions", value: "actions", sortable: false, align: "end" },
      ],
     
     /*Soporte*/
      valida: 0,
      validamensaje: [],
      editedIndexDetalle: -1,
      loading: false,
      mensaje: "",
      tipoMensaje: "",
      tieneTransporte: false,
      tieneMaquinaria: false,
      tieneCombustible: false,
      tieneAlojamiento: false,
      tieneAlimentacion: false,
      tieneOtrosBienes: false,
      tieneOtrosServicios: false,
    };
  },
  created() {
    this.listar();
    this.selectempresa();
    this.selectLocacion();
    this.cargarCategorias();
    let me = this;
    // Add a request interceptor
    axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        me.overlay2 = true;
        return config;
      },
      function (error) {
        // Do something with request error
        me.overlay2 = false;
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause me function to trigger
        // Do something with response data
        me.overlay2 = false;
        //me.overlay=false;
        return response;
      },
      function (error) {
        // Any status codes that falls outside the range of 2xx cause me function to trigger
        // Do something with response error
        return Promise.reject(error);
        me.overlay2 = false;
      }
    );
  },

  computed: {
    form1() {
      return {
        ruc: this.ruc,
        razonsocial: this.razonsocial.toUpperCase(),
        fecha_presentacion: this.fecha_presentacion,
        sector: this.sector,
        representante_cel: this.representante_cel,
        correo: this.correo,
        nombre_comercial: this.nombre_comercial,
        carta_presentacion: this.carta_presentacion,
        mesa_trabajo: this.mesa_trabajo,
        diagnostico_ccia: this.isTrue(this.diagnostico_ccia) ? "Si" : "No",
        direccion_declarada: this.direccion_declarada,
        departamento: this.departamento,
        provincia: this.provincia,
        distrito: this.distrito,
        // puntaje_antiguedad: this.puntaje_antiguedad,
        representante: this.representante,
        porcentaje_pro: this.porcentaje_pro,
        representante_dni: this.representante_dni,
        fecha_emi_dni: this.fecha_emi_dni,
        ubigeo_nacimiento: this.ubigeo_nacimiento,
        // lugar_nacimiento: this.lugar_nacimiento,
        // influencia_dni: this.influencia_dni,
        residencia: this.residencia,
        // influencia_residencia: this.influencia_residencia,
        // puntaje_residencia: this.puntaje_residencia,
        // localia_representante: this.localia_representante,
        // puntaje_localia: this.puntaje_localia,
        // domicilio_fiscal: this.domicilio_fiscal,
        // area_influencia_ruc: this.area_influencia_ruc,
        // puntaje_localia_dom: this.puntaje_localia_dom,
        // resultado_final_localia: this.resultado_final_localia,
        // puntaje_total_localia: this.puntaje_total_localia,
        comentario: this.comentario,
        // categoria_proveedor: this.categoria_proveedor,
        // fecha_inicio_ruc: this.fecha_inicio_ruc
        // tipo_empresa: this.tipo_empresa,
        // tipo_locacion: this.tipo_locacion,
       };
    },
    form2() {
      return {
        contratosempresasname: this.contratosempresasname,
      };
    },
    // tieneAlimentacion () {
    //   return this.lista_rubros.some(
    //     r => r.id_rubro_tipo_servicio === this.rubros.alimentacion
    //   )
    // },
    // tieneAlojamiento () {
    //   return this.lista_rubros.some(
    //     r => r.id_rubro_tipo_servicio === this.rubros.alojamiento
    //   )
    // },
    // tieneTransporte () {
    //   return this.lista_rubros.some(
    //     r => r.id_rubro_tipo_servicio === this.rubros.transporte
    //   )
    // },
    // tieneMaquinaria () {
    //   return this.lista_rubros.some(
    //     r => r.id_rubro_tipo_servicio === this.rubros.maquinaria
    //   )
    // },
    // tieneCombustible () {
    //   return this.lista_rubros.some(
    //     r => r.id_rubro_tipo_servicio === this.rubros.combustible
    //   )
    // },
    // tieneOtrosBienes () {
    //   return this.lista_rubros.some(
    //     r => r.id_rubro_tipo_servicio === this.rubros.otrosservicios
    //   )
    // },
    // tieneOtrosServicios () {
    //   return this.lista_rubros.some(
    //     r => r.id_rubro_tipo_servicio === this.rubros.otrosservicios
    //   )
    // },
    estadoColor() {
      switch (this.localia_representante) {
        case 'Local':
        case 'LOCAL':
          return 'green'
        case 'Foránea':
          return 'red'
        case 'NO LOCAL':
          return 'red'
        case 'Por definir':
          return 'amber'
        default:
          return 'grey'
      }
    }
  },
  methods: {
    isDate(value) {
      switch (typeof value) {
        case "number":
          return true;
        case "string":
          return !isNaN(Date.parse(value));
        case "object":
          if (value instanceof Date) {
            return !isNaN(value.getTime());
          }
        default:
          return false;
      }
    },
    /*Empresa*/
    ActivarDesactivar(item) {
      //La adAccion 1 = Activar y 2 = Desactivar
      this.adModal = 1;
      this.adNombre = item.razonsocial;
      this.adId = item.idempresa;
      if (item.condicion) {
        this.adAccion = 1;
      } else {
        this.adAccion = 2;
      }
    },
    ActivarDesactivarCerrar() {
      this.adModal = 0;
      this.listar();
      this.selectempresa();
    },
    Activar() {
      let me = this;
      axios
        .put("/api/Empresas/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          //me.adAccion=1;
          me.adnombre = "";
          me.id = "";
          me.listar();
          me.selectempresa();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    Desactivar() {
      let me = this;
      axios
        .put("/api/Empresas/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          //me.adAccion=1;
          me.adnombre = "";
          me.id = "";
          me.listar();
          me.selectempresa();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    validar1() {
      /*Validacion Forms */
      this.error = null;
      this.form1HasErrors = false;

      Object.keys(this.form1).forEach((f) => {
        if (!this.form1[f]) {
          this.form1HasErrors = true;
          this.$refs[f]?.focus();
        }

        const ref = this.$refs[f];

        if (ref && typeof ref.validate === "function") {
          ref.validate(true);
        } else {
          console.warn(`El ref '${f}' no existe o no tiene validate()`);
        }
      });
      if (this.form1HasErrors) {
        this.mensaje = "Debe completar los campos obligatorios";
        this.tipoMensaje = "error";
      }
    },

    editItemEmpresa(item) {
      this.overlay = true;
      this.idempresa = item.idempresa;
      this.registro = true;
      this.editItem();
      this.overlay = false;
    },
    /* Tabla */
    listar() {
      let me = this;
      me.empresa_item=[];
      axios
        .get("api/Empresas/Listar")
        .then(function (response) {
          me.empresa_item = response.data;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },

    selectempresa() {
      let me = this;
      var Array = [];
      me.empresas = [];
      axios
        .get("api/Empresas/SelectEmpresas")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.empresas.push({ text: x.razonsocial, value: x.idempresa });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error.response);
        });
    },
    selectLocacion() {
      let me = this;
      var Array = [];
      me.llocaciones = [];
      axios
        .get("api/ListLocaciones")
        .then(function (response) {
          Array = response.data;
          Array.map(function (x) {
            me.llocaciones.push({ text: x.locacion, value: x.idlocacion });
          });
        })
        .catch(function (error) {
          //Porahora lo mostramos en consola
          console.log(error.response);
        }); 
    },

    editItem() {
      this.overlay = true;
      let me = this;
      var Array = [];
      axios
        .get("api/Empresas/Mostrar/" + me.idempresa)
        .then(function (response) {
          //console.log(response.data.idempresa);
          me.idempresa = response.data.idempresa;
          me.ruc = response.data.ruc;
          me.fecha_presentacion = response.data.fecha_presentacion?.split("T")[0] || "";
          me.razonsocial = response.data.razonsocial;
          me.sector = response.data.sector;
          me.rubro_tipo_servicio = response.data.rubro_tipo_servicio;
          me.especialidad = response.data.especialidad;
          me.representante_cel = response.data.representante_cel;
          me.correo = response.data.correo;
          me.nombre_comercial = response.data.nombre_comercial;
          me.carta_presentacion = response.data.carta_presentacion;
          me.mesa_trabajo = response.data.mesa_trabajo;
          me.diagnostico_ccia = response.data.diagnostico_ccia.toUpperCase() === "SI";
          me.direccion_declarada = response.data.direccion_declarada;
          me.departamento = response.data.departamento;
          me.provincia = response.data.provincia;
          me.distrito = response.data.distrito;
          me.puntaje_antiguedad = me.puntaje_antiguedad;
          me.representante = response.data.representante;
          me.porcentaje_pro = response.data.porcentaje_pro;
          me.representante_dni = response.data.representante_dni;
          me.fecha_emi_dni = response.data.fecha_inicio_ruc
            ? response.data.fecha_inicio_ruc.split("T")[0]
            : null;
          me.ubigeo_nacimiento = response.data.ubigeo_nacimiento;
          me.lugar_nacimiento = response.data.lugar_nacimiento;
          me.influencia_dni = response.data.influencia_dni;
          me.residencia = response.data.residencia;
          me.influencia_residencia = response.data.influencia_residencia;
          me.puntaje_residencia = response.data.puntaje_residencia;
          me.localia_representante = response.data.localia_representante;
          me.puntaje_localia = response.data.puntaje_localia;
          me.domicilio_fiscal = response.data.domicilio_fiscal;
          me.area_influencia_ruc = response.data.area_influencia_ruc;
          me.puntaje_localia_dom = response.data.puntaje_localia_dom;
          me.resultado_final_localia = response.data.resultado_final_localia;
          me.puntaje_total_localia = response.data.puntaje_total_localia;
          me.comentario = response.data.comentario;
          me.empresa_foranea = response.data.empresa_foranea.toUpperCase() === "SI";
          me.categoria_proveedor = response.data.categoria_proveedor;
          me.fecha_inicio_ruc = response.data.fecha_inicio_ruc
              ? response.data.fecha_inicio_ruc.split("T")[0]
              : null;
          me.correo_cobertura = response.data.correo_cobertura,
          me.respuesta_cobertura = response.data.respuesta_cobertura,
          me.comentario_cobertura = response.data.comentario_cobertura,
          me.usuarios_concatenados = response.data.usuarios_concatenados,
          me.editedIndex = 1;
          me.nuevo = false;
          me.cargarRubrosEmpresas();
          me.cargarDetallesEmpresa();
          // me.mostrargaraje(me.idempresa);
          // me.mostrarflota(me.idempresa);
          me.mostrarInfo = true;
        })
        .catch(function (error) {
          console.log(error);
        });
      this.overlay = false;
    },
    editItemEmpresa(item) {
      this.idempresa = item.idempresa;
      this.ruc = item.ruc;
      this.fecha_presentacion = item.fecha_presentacion;
      this.razonsocial = item.razonsocial;
      this.abreviatura = item.abreviatura;
      this.tipo_empresa = item.tipo_empresa;
      this.sector = item.sector;
      this.descripcion = item.descripcion;
      this.representante = item.representante;
      this.representante_dni = item.representante_dni;
      this.representante_cel = item.representante_cel;
      this.primer_contacto = item.primer_contacto;
      this.segundo_contacto = item.segundo_contacto;
      this.giro_comercial = item.giro_comercial;
      this.pro_ser_principal = item.pro_ser_principal;
      this.pro_ser_secundario = item.pro_ser_secundario;
      this.licencia = item.licencia;
      this.numero_licencia = item.numero_licencia;
      this.boleta = item.boleta;
      this.factura = item.factura;
      this.locacion = item.locacion;
      this.mesa_trabajo = item.mesa_trabajo;
      this.sede = item.sede;
      this.correo = item.correo;
      this.servicio1 = item.servicio1;
      this.servicio2 = item.servicio2;
      this.servicio3 = item.servicio3;
      this.servicio4 = item.servicio4;
      this.servicio5 = item.servicio5;
      this.servicio6 = item.servicio6;
      this.ubigeo_nacimiento = item.ubigeo_nacimiento;
      this.lugar_nacimiento = item.lugar_nacimiento;
      this.residencia = item.residencia;
      this.influencia_dni = item.influencia_dni;
      this.fecha_emi_dni = item.fecha_emi_dni;
      this.pendiente = item.pendiente;
      this.comentario = item.comentario;
      this.porcentaje_pro = item.porcentaje_pro;
      this.diagnostico = item.diagnostico;
      this.porcentaje = item.porcentaje;
      this.grado_madurez = item.grado_madurez;
      this.porcentaje_avance = item.porcentaje_avance;
      this.localia = item.localia;
      this.observacion = item.observacion;
      this.correo_cobertura = item.correo_cobertura,
      this.respuesta_cobertura = item.respuesta_cobertura,
      this.comentario_cobertura = item.comentario_cobertura,
      this.editedIndex = 1;
    },

    isTrue(value){
        if (typeof(value) === 'string'){
            value = value.trim().toLowerCase();
        }
        switch(value){
            case true:
            case "true":
            case 1:
            case "1":
            case "on":
            case "yes":
                return true;
            default: 
                return false;
        }
    },

    limpiar() {
      this.idempresa = "";
      this.ruc = "";
      this.razonsocial = "";
      this.abreviatura = "";
      this.sector = "";
      this.descripcion = "";
      this.tipo_empresa = "";
      this.tipo_locacion = "";
      this.representante = "";
      this.representante_dni = "";
      this.representante_cel = "";
      this.primer_contacto = "";
      this.segundo_contacto = "";
      this.giro_comercial = "";
      this.pro_ser_principal = "";
      this.pro_ser_secundario = "";
      this.licencia = "";
      this.numero_licencia = "";
      this.boleta = "";
      this.factura = "";
      this.locacion = "";
      this.editedIndex = -1;
      this.limpiarContratosEmpresasTotal();
      this.nuevo = true;
      this.mesa_trabajo = "";
      this.sede = "";
      this.correo = "";
      this.servicio1 = "";
      this.servicio2 = "";
      this.servicio3 = "";
      this.servicio4 = "";
      this.servicio5 = "";
      this.servicio6 = "";
      this.ubigeo_nacimiento = "";
      this.lugar_nacimiento = "";
      this.residencia = "";
      this.influencia_dni = "";
      this.fecha_emi_dni = "";
      this.pendiente = "";
      this.comentario = "";
      this.porcentaje_pro = "";
      this.diagnostico = "";
      this.porcentaje = "";
      this.grado_madurez = "";
      this.porcentaje_avance = "";
      this.localia = "";
      this.observacion = "";
      this.domicilio_fiscal = "";
      this.fecha_inicio_ruc = "";
      this.direccion_fiscal = "";
      this.fecha_presentacion = "";
      this.correo_cobertura = "";
      this.respuesta_cobertura = "";
      this.comentario_cobertura = "";
      this.mostrarInfo = false;
    },
    async saveRubros() {
      let me = this;
      // me.validar2();
      if (me.CheckListaRubros == false) {
        // console.log(me.lista_rubros);
        // console.log(me.editedIndexDetalle);
        for (const item of me.lista_rubros) {
          // console.log(item);
          if (item.id_rubro_tipo_servicio) {
            continue;
          }
          if (me.editedIndexDetalle > -1) {
              let me = this;
              axios
                .put("/api/RubrosEmpresas/Actualizar", {
                  id_rubroempresa: item.id_rubroempresa,
                  id_rubro_tipo_servicio: item.id_rubro_tipo_servicio,
                  especialidad: item.especialidad,
                  id_empresa: me.idempresa,
                })
                .then(function (response) {
                  me.color = "#2A3B4D";
                  me.icon = "mdi-thumb-up";
                  me.error = "Registro exitoso";
                  me.snackbar = true;
                  me.dialogrubros = false;
                })
                .catch(function (error) {
                  console.log(error.response);
                  if (error.response.status == 400) {
                    me.error = error.response.data.toString();
                  }
                  me.color = "#E53935";
                  me.icon = "mdi-alert";
                  me.overlay2 = false;
                  me.snackbar = true;
                });
            } else {
              let me = this;
              // console.log(this.idempresa)
              axios
                .post("/api/RubrosEmpresas/Crear", {
                  id_rubro_tipo_servicio: item.id_rubro_tipo_servicio,
                  especialidad: item.especialidad,
                  id_empresa: me.idempresa,
                })
                .then(function (response) {
                  me.color = "#2A3B4D";
                  me.icon = "mdi-thumb-up";
                  me.error = "Registro exitoso";
                  me.snackbar = true;
                  me.dialogrubros = false;
                })
                .catch(function (error) {
                  console.log(error.response);
                  if (error.response.status == 400) {
                    me.error = error.response.data.toString();
                  }
                  me.color = "#E53935";
                  me.icon = "mdi-alert";
                  me.overlay2 = false;
                  me.snackbar = true;
                });
            }
          }
      }
    },
    async save() {
      this.validar1();
      if (this.form1HasErrors) return;

      let me = this;

      try {
        if (this.editedIndex > -1) {
          // 🔵 ACTUALIZAR
          await axios.put("/api/Empresas/Actualizar", {
            idempresa: me.idempresa,
            ruc: me.ruc,
            razonsocial: me.razonsocial.toUpperCase(),
            fecha_presentacion: me.fecha_presentacion,
            sector: me.sector,
            // rubro_tipo_servicio: me.rubro_tipo_servicio,
            especialidad: me.especialidad,
            representante_cel: me.representante_cel,
            correo: me.correo,
            nombre_comercial: me.nombre_comercial,
            carta_presentacion: me.carta_presentacion,
            mesa_trabajo: me.mesa_trabajo,
            diagnostico_ccia: me.isTrue(me.diagnostico_ccia) ? "Si" : "No",
            direccion_declarada: me.direccion_declarada,
            departamento: me.departamento,
            provincia: me.provincia,
            distrito: me.distrito,
            puntaje_antiguedad: me.puntaje_antiguedad,
            representante: me.representante,
            porcentaje_pro: me.porcentaje_pro,
            representante_dni: me.representante_dni,
            fecha_emi_dni: me.fecha_emi_dni,
            ubigeo_nacimiento: me.ubigeo_nacimiento,
            lugar_nacimiento: me.lugar_nacimiento,
            influencia_dni: me.influencia_dni,
            residencia: me.residencia,
            influencia_residencia: me.influencia_residencia,
            puntaje_residencia: me.puntaje_residencia,
            localia_representante: me.localia_representante,
            puntaje_localia: me.puntaje_localia,
            domicilio_fiscal: me.domicilio_fiscal,
            area_influencia_ruc: me.area_influencia_ruc,
            puntaje_localia_dom: me.puntaje_localia_dom,
            resultado_final_localia: me.resultado_final_localia,
            puntaje_total_localia: me.puntaje_total_localia,
            comentario: me.comentario,
            empresa_foranea: me.isTrue(me.empresa_foranea) ? "Si" : "No",
            categoria_proveedor: me.categoria_proveedor,
            fecha_inicio_ruc: me.fecha_inicio_ruc,
            correo_cobertura: me.correo_cobertura,
            respuesta_cobertura: me.respuesta_cobertura,
            comentario_cobertura: me.comentario_cobertura,
          });
        } else {
          // 🟢 CREAR
          const response = await axios.post("/api/Empresas/Crear", {
            ruc: me.ruc,
            razonsocial: me.razonsocial.toUpperCase(),
            fecha_presentacion: me.fecha_presentacion,
            sector: me.sector,
            // rubro_tipo_servicio: me.rubro_tipo_servicio,
            especialidad: me.especialidad,
            representante_cel: me.representante_cel,
            correo: me.correo,
            nombre_comercial: me.nombre_comercial,
            carta_presentacion: me.carta_presentacion,
            mesa_trabajo: me.mesa_trabajo,
            diagnostico_ccia: me.isTrue(me.diagnostico_ccia) ? "Si" : "No",
            direccion_declarada: me.direccion_declarada,
            departamento: me.departamento,
            provincia: me.provincia,
            distrito: me.distrito,
            puntaje_antiguedad: me.puntaje_antiguedad,
            representante: me.representante,
            porcentaje_pro: me.porcentaje_pro,
            representante_dni: me.representante_dni,
            fecha_emi_dni: me.fecha_emi_dni,
            ubigeo_nacimiento: me.ubigeo_nacimiento,
            lugar_nacimiento: me.lugar_nacimiento,
            influencia_dni: me.influencia_dni,
            residencia: me.residencia,
            influencia_residencia: me.influencia_residencia,
            puntaje_residencia: me.puntaje_residencia,
            localia_representante: me.localia_representante,
            puntaje_localia: me.puntaje_localia,
            domicilio_fiscal: me.domicilio_fiscal,
            area_influencia_ruc: me.area_influencia_ruc,
            puntaje_localia_dom: me.puntaje_localia_dom,
            resultado_final_localia: me.resultado_final_localia,
            puntaje_total_localia: me.puntaje_total_localia,
            comentario: me.comentario,
            empresa_foranea: me.isTrue(me.empresa_foranea) ? "Si" : "No",
            categoria_proveedor: me.categoria_proveedor,
            fecha_inicio_ruc: me.fecha_inicio_ruc,
            correo_cobertura: me.correo_cobertura,
            respuesta_cobertura: me.respuesta_cobertura,
            comentario_cobertura: me.comentario_cobertura,
          });

          me.idempresa = Number(response.data);
        }

        // ✅ AQUÍ sí es válido usar await
        await me.saveRubros();
        await me.saveRubrosEspeciales();

        me.color = "#2A3B4D";
        me.icon = "mdi-thumb-up";
        me.error = "Registro exitoso";
        me.snackbar = true;
        me.nuevo = false;
        me.mensaje = "Registro exitoso";
        me.tipoMensaje = "success";
        setTimeout(() => {
          me.mensaje = "";
        }, 3000);

        me.selectempresa();
        me.listar();

      } catch (error) {
        console.error(error);
        me.color = "#E53935";
        me.icon = "mdi-alert";
        me.error = error.response?.data || "Error al guardar";
        me.snackbar = true;
        me.mensaje = "Ocurrió un error al guardar";
        me.tipoMensaje = "error";
      }
    },

    /* contratosempresas */
    validar2() {
      /*Validacion Forms */
      this.error = null;
      this.form2HasErrors = false;

      Object.keys(this.form2).forEach((f) => {
        if (!this.form2[f]) this.form2HasErrors = true;
        this.$refs[f].validate(true);
      });

      if (this.idempresa == null || this.idempresa == "") {
        this.error = "Debe selecionar una persona previamente";
        this.snackbar = true;
        this.color = "#E53935";
        this.icon = "mdi-alert";
        this.form2HasErrors = true;
      }
    },
    
    abrirDialogContratosEmpresas() {
      this.dialogcontratosempresas = true;
      this.limpiarContratosEmpresas();
    },
    
    /* contratosempresas*/
    limpiarContratosEmpresas() {
      this.contratosempresasid = "";
      this.contratosempresasname = "";
      this.contratosempresasabreviatura = "";
      this.contratosempresasdescripcion = "";
      this.contratosempresasfecha_inicio = "";
      this.contratosempresasfecha_fin = "";
      this.contratosempresasconflictivo = "";
      this.contratosempresasobservaciones = "";
      this.contratosempresasmonto_contrato = "";
      this.contratosempresasservicio_calidad = "";
      this.contratosempresasservicio_observaciones = "";
      this.editedIndexContratosEmpresas = -1;
    },
    limpiarContratosEmpresasTotal() {
      this.limpiarContratosEmpresas();
      this.contratosempresass = [];
      this.contadorcontratos = 0;
    },
    listarContratosEmpresas() {
      let me = this;
      axios
        .get(
          "api/ContratosEmpresas/GetContratosEmpresasByEmpresa/?empresaId=" +
            me.idempresa.toString()
        )
        .then((response) => {
          var obj = response.data;
          var res = [];

          for (var i in obj) {
            res.push(obj[i]);
          }
          me.contratosempresass = res;
          me.contadorcontratos = obj.length;
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    editItemContratosEmpresas(item) {
      this.dialogcontratosempresas = true;
      this.contratosempresasid = item.idcontratosempresas;
      this.contratosempresasname = item.contratosempresas;
      this.contratosempresasabreviatura = item.abreviatura;
      this.contratosempresasdescripcion = item.descripcion;
      this.contratosempresasfecha_inicio = item.fecha_inicio;
      this.contratosempresasfecha_fin = item.fecha_fin;
      this.contratosempresasconflictivo = item.conflictivo;
      this.contratosempresasobservaciones = item.observaciones;
      this.contratosempresasmonto_contrato = item.monto_contrato;
      this.contratosempresasservicio_calidad = item.servicio_calidad;
      this.contratosempresasservicio_observaciones = item.servicio_observaciones;
      this.editedIndexContratosEmpresas = 1;
    },
   
    saveContratosEmpresas() {
      let me = this;
      me.validar2();
      console.log("Sale de valida 2" + me.form2HasErrors.toString());
      if (me.form2HasErrors == false) {
      console.log("Llega a entrar a crear area");
      if (this.editedIndexContratosEmpresas > -1) {
        let me = this;
        console.log("Actualizar");
        axios
          .put("/api/ContratosEmpresas/Actualizar", {
            idcontratosempresas: me.contratosempresasid,
            contratosempresas: me.contratosempresasname.toUpperCase(),
            abreviatura: me.contratosempresasabreviatura,
            descripcion: me.contratosempresasdescripcion.toString().toUpperCase(),
            idempresa: me.idempresa,
            fecha_inicio: me.contratosempresasfecha_inicio,
            fecha_fin: me.contratosempresasfecha_fin,
            conflictivo: me.contratosempresasconflictivo,
            observaciones: me.contratosempresasobservaciones,
            monto_contrato: me.contratosempresasmonto_contrato,
            servicio_calidad: me.contratosempresasservicio_calidad,
            servicio_observaciones: me.contratosempresasservicio_observaciones,
          })
          .then(function (response) {
            me.listarContratosEmpresas();
            me.listar();
            me.limpiarContratosEmpresas();
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Registro exitoso";
            me.snackbar = true;
            me.dialogcontratosempresas = false;
          })
          .catch(function (error) {
            console.log(error.response);
            me.error = error.response.data.toString();
            me.color = "#E53935";
            me.icon = "mdi-alert";
            me.overlay2 = false;
            me.snackbar = true;
          });
      } else {
        console.log("Crear");
        let me = this;
        axios
          .post("/api/ContratosEmpresas/Crear", {
            contratosempresas: me.contratosempresasname.toUpperCase(),
            abreviatura: me.contratosempresasabreviatura,
            descripcion: me.contratosempresasdescripcion.toString().toUpperCase(),
            idempresa: me.idempresa,
            fecha_inicio: me.contratosempresasfecha_inicio,
            fecha_fin: me.contratosempresasfecha_fin,
            conflictivo: me.contratosempresasconflictivo,
            observaciones: me.contratosempresasobservaciones,
            monto_contrato: parseFloat(me.contratosempresasmonto_contrato),
            servicio_calidad: me.contratosempresasservicio_calidad,
            servicio_observaciones: me.contratosempresasservicio_observaciones,
          })
          .then(function (response) {
            me.listar();
            me.listarContratosEmpresas();
            me.limpiarContratosEmpresas();
            me.color = "#2A3B4D";
            me.icon = "mdi-thumb-up";
            me.error = "Registro exitoso";
            me.snackbar = true;
            me.dialogcontratosempresas = false;
          })
          .catch(function (error) {
            console.log(error.response);
            if (error.response.status == 400) {
              me.error = error.response.data.toString();
            }
            me.color = "#E53935";
            me.icon = "mdi-alert";
            me.overlay2 = false;
            me.snackbar = true;
          });
        }
      }
    },
    validar() {
      this.valida = 0;
      this.validamensaje = [];
      //Interesante con este codigo digo si tengo almenos 1 objeto en el array
      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },
    calcularPuntajeAntiguedad(fecha) {
      // console.log(fecha)
      if (!fecha) return 0;

      const hoy = new Date();
      // console.log(hoy)
      const f = new Date(fecha);
      // console.log(f)

      // calcular años completos
      let years = hoy.getFullYear() - f.getFullYear();
      // console.log(years)

      // restar 1 si aún no cumple el año este año (como Excel)
      const cumpleEsteAnio =
        new Date(hoy.getFullYear(), f.getMonth(), f.getDate()) <= hoy;

      if (!cumpleEsteAnio) {
        years -= 1;
      }

      // aplicar fórmula Excel
      if (years > 5) return 10;
      if (years >= 2) return 5;
      return 0;
    },
    getAreaInfluencia(distrito) {
      const name = distrito.trim().toLowerCase();

      const AID = ["cocachacra", "dean valdivia", "mejia"];
      const AII = ["punta de bombon", "mollendo", "islay"];

      if (AID.includes(name)) return "AID";
      if (AII.includes(name)) return "AII";
      return "Foránea";
    },
    calcularPuntaje(fechaStr) {
      if (!fechaStr) return 0;

      const fecha = new Date(fechaStr);
      const hoy = new Date();

      let years = hoy.getFullYear() - fecha.getFullYear();

      // ¿Ya cumplió años este año? -> Igual que Excel
      const haCumplido =
        new Date(hoy.getFullYear(), fecha.getMonth(), fecha.getDate()) <= hoy;

      if (!haCumplido) {
        years -= 1;
      }

      if (years >= 5) return 10;
      if (years >= 2) return 5;
      return 0;
    },
    calcularLocalidad(influenciaResidencia, influenciaDni) {
      const valRes = influenciaResidencia?.trim().toUpperCase();
      const valDni = influenciaDni?.trim().toUpperCase();

      if (valRes === "AID" || valRes === "AII") return "Local";
      if (valDni === "AID" || valDni === "AII") return "Local";

      return "Foránea";
    },
    calcularPuntajeLocalia() {
      const U = this.porcentaje_pro / 100;     // convertir 0-100 → 0-1
      const Z = this.influencia_dni;           // AID, AII, Foránea
      const AB = this.influencia_residencia;   // AID, AII, Foránea

      // Regla 1
      if (U === 1 && Z === "AID" && AB === "AID") {
        this.puntaje_localia = 50;
        return;
      }

      // Regla 2
      if (
        U >= 0.5 &&
        (Z === "AID" || Z === "AII") &&
        (AB === "AID" || AB === "AII")
      ) {
        this.puntaje_localia = 30;
        return;
      }

      // Regla 3
      if (
        U >= 0.5 &&
        (Z === "AID" || Z === "AII") &&
        AB === "Foránea"
      ) {
        this.puntaje_localia = 10;
        return;
      }

      // Regla 4
      if (
        U >= 0.5 &&
        (AB === "AID" || AB === "AII") &&
        Z === "Foránea"
      ) {
        this.puntaje_localia = 10;
        return;
      }

      // Valor por defecto
      this.puntaje_localia = 0;
    },
    calcularInfluencia(valor) {
      if (!valor) return "Foránea";

      const val = valor.trim().toLowerCase();

      const AID = ["cocachacra", "dean valdivia", "mejia"];
      const AII = ["punta de bombon", "mollendo", "islay"];

      if (AID.includes(val)) return "AID";
      if (AII.includes(val)) return "AII";

      return "Foránea";
    },
    calcularPuntajeLocaliaPorDomicilioFiscal(area) {
      if (!area) return 0;

      const val = area.trim().toUpperCase();

      if (val === "AID") return 30;
      if (val === "AII") return 18;

      return 0; // Default para Foránea u otros valores
    },
    calcularResidenciaFinal(categoria) {
      // calcularResidenciaFinal(z, ab, ag) {
      // const valoresLocal = ["AID", "AII"];

      // // Si alguno es vacío o null → Por definir
      // if (
      //   (!z || z.toString().trim() === "") ||
      //   (!ab || ab.toString().trim() === "") ||
      //   (!ag || ag.toString().trim() === "")
      // ) {
      //   return "Por definir";
      // }

      // const zVal = z.toString().trim().toUpperCase();
      // const abVal = ab.toString().trim().toUpperCase();
      // const agVal = ag.toString().trim().toUpperCase();

      // if (valoresLocal.includes(zVal)) return "Local";
      // if (valoresLocal.includes(abVal)) return "Local";
      // if (valoresLocal.includes(agVal)) return "Local";

      // return "Foránea";
      const mapa = {
        "Categoría A: Proveedor Local Estratégico": "Local",
        "Categoría B: Proveedor Local Genuino": "Local",
        "Categoría C: Proveedor Local en Desarrollo": "Local",
        "Categoría D: Proveedor Originario de la Zona": "Local",
        "Categoría E: Proveedor Consorciado con Componente Local": "Foránea",
        "Categoría F: Proveedor Regional Registrado": "Foránea",
        "Categoría G: Proveedor Foráneo No Aplicable": "Foránea"
      };

      return mapa[categoria] || "Por definir";
    },
    // actualizarResidenciaFinal() {
    //   this.resultado_final_localia = this.calcularResidenciaFinal(
    //     this.influencia_dni,
    //     this.influencia_residencia,
    //     this.area_influencia_ruc
    //   );
    // },
    actualizarResidenciaFinal() {
      this.resultado_final_localia = this.calcularResidenciaFinal(
        this.categoria_proveedor
      );
    },
    calcularPuntajeTotalLocalia() {
      // Validar si falta alguno de los valores numéricos requeridos
      if (
        this.puntaje_antiguedad == null ||
        this.puntaje_localia == null ||
        this.puntaje_localia_dom == null ||
        this.puntaje_residencia == null
      ) {
        return "Por definir";
      }

      // Validar si la residencia existe (si viene vacía → Por definir)
      if (!this.influencia_residencia || this.influencia_residencia.toString().trim() === "") {
        return "Por definir";
      }

      const influencia = this.influencia_residencia.toString().trim().toUpperCase();
      const esLocal = ["AID", "AII"].includes(influencia);

      const puntajeResidencia = esLocal ? this.puntaje_residencia : 0;

      return (
        this.puntaje_antiguedad +
        puntajeResidencia +
        this.puntaje_localia +
        this.puntaje_localia_dom
      );
    },
    actualizarTotalLocalia() {
      this.puntaje_total_localia = this.calcularPuntajeTotalLocalia();
    },
    calcularEmpresaForanea(comentario) {
      if (!comentario) return false;

      return comentario.toLowerCase().includes("vientre");
    },
    calcularCategoriaProveedor() {
      if (this.puntaje_total_localia === "Por definir") {
        this.categoria_proveedor = "Por definir";
        return;
      }

      if (this.empresa_foranea === true) {
        this.categoria_proveedor = "Categoría E: Proveedor Consorciado con Componente Local";
        return;
      }

      const puntaje = Number(this.puntaje_total_localia);

      if (puntaje >= 83) {
        this.categoria_proveedor =
          "Categoría A: Proveedor Local Estratégico";
        return;
      }

      if (puntaje >= 63) {
        this.categoria_proveedor =
          "Categoría B: Proveedor Local Genuino";
        return;
      }

      // 🔹 CAMBIO: antes era >= 40
      if (puntaje >= 43) {
        this.categoria_proveedor =
          "Categoría C: Proveedor Local en Desarrollo";
        return;
      }

      // 🔹 CAMBIO: nueva lógica de Categoría D
      const esCategoriaD =
        (
          this.puntaje_residencia === 10 &&
          (this.influencia_residencia === "AID" ||
           this.influencia_residencia === "AII")
        ) ||
        (this.influencia_dni === "AID" ||
         this.influencia_dni === "AII");

      if (esCategoriaD) {
        this.categoria_proveedor =
          "Categoría D: Proveedor Originario o Residente Local";
        return;
      }

      if (puntaje >= 5) {
        this.categoria_proveedor =
          "Categoría F: Proveedor Regional Registrado";
        return;
      }
      this.categoria_proveedor =
          "Categoría G: Proveedor Foráneo No Aplicable";
    },
    async cargarCategorias() {
      try {
        const response = await axios.get("/api/CategoriaServicios/Listar");
        this.rubro_tipo_s = response.data;
        // console.log(this.rubro_tipo_s)
      } catch (error) {
        console.error("Error cargando categorías:", error);
      }
    },
    async cargarCategorias_diag() {
      try {
        const response = await axios.get("/api/CategoriaServicios/Listar");
        this.rubro_tipo_ss = response.data;
        // console.log(this.rubro_tipo_s)
      } catch (error) {
        console.error("Error cargando categorías:", error);
      }
    },
    async cargarDetallesEmpresa() {

      await this.mostrarflota(this.idempresa);

      await this.mostrarmaquinaria(this.idempresa);

      await this.mostrarplantagrifo(this.idempresa);

      await this.mostrarhospedaje(this.idempresa);

      await this.mostrarcocinaplanta(this.idempresa);

      await this.mostrarotrosbienes(this.idempresa);

      await this.mostrarotrosservicios(this.idempresa);

    },
    async cargarRubrosEmpresas() {
      try {
        const response = await axios.get(`/api/RubrosEmpresas/ListarPorEmpresa?idEmpresa=${this.idempresa}`);
        // console.log(response.data)
        this.lista_rubros = response.data.map(rubro => {
        const tipo = this.rubro_tipo_s.find(
          r => r.id === rubro.id_rubro_tipo_servicio
        );
        const rubrosIds = response.data
          .map(rubro =>
            this.rubro_tipo_s.find(r => r.id === rubro.id_rubro_tipo_servicio)?.id
          )
          .filter(Boolean);
        // if (rubrosIds.includes(1)) {
        //   this.mostrargaraje(this.idempresa);
        // }

        return {
          ...rubro,
          rubro_tipo_servicio_nombre: tipo ? tipo.nombrecategoria : ""
        };
      });
      } catch (error) {
        console.error("Error cargando categorías:", error);
      }
    },
    abrirDialogRubros() {
        this.dialogrubros = true;
        this.limpiarRubros();
        this.cargarCategorias_diag();
    },
    editItemDetalle(item) {
      this.dialogrubros = true
      this.cargarCategorias_diag();

      // guarda el índice correctamente
      this.editIndex = this.lista_rubros.findIndex(
        r => r.id_rubroempresa === item.id_rubroempresa
      )

      // cargar valores reales del item
      this.rubro_tipo_servicio_di = item.id_rubro_tipo_servicio
      this.especialidad = item.especialidad

      // marca como edición
      this.editedIndexDetalle = 1
    },
    limpiarRubros() {
      this.rubro_tipo_servicio_di = "";
      this.especialidad = "";
      this.editedIndexDetalle = -1;
    },
    agregarRubro() {
      const rubro = this.rubro_tipo_ss.find(
        r => r.id === this.rubro_tipo_servicio_di
      )

      if (!rubro) {
        console.warn('Rubro no encontrado')
        return
      }

      const data = {
        id_rubro_tipo_servicio: rubro.id,
        rubro_tipo_servicio_nombre: rubro.nombrecategoria,
        especialidad: this.especialidad
      }

      // 🟢 EDITAR
      if (this.editIndex >= 0) {
        Object.assign(this.lista_rubros[this.editIndex], data)
      }
      // 🔵 AGREGAR
      else {
        this.lista_rubros.push(data)
      }

      // limpiar estado
      this.editIndex = -1
      this.dialogrubros = false
    },
    deleteItemRubro(item) {
      if (!confirm("¿Está seguro(a) que desea eliminar este rubro?")) {
        return
      }

      // buscar el índice usando el ID REAL
      const index = this.lista_rubros.findIndex(
        r => r.id_rubroempresa === item.id_rubroempresa
      )

      if (index === -1) {
        console.warn("Rubro no encontrado en lista_rubros")
        return
      }

      axios
        .delete(`/api/RubrosEmpresas/Eliminar/${item.id_rubroempresa}`)
        .then(() => {
          // eliminar del frontend solo si backend OK
          this.lista_rubros.splice(index, 1)

          this.color = "#2A3B4D"
          this.icon = "mdi-thumb-up"
          this.error = "Rubro eliminado correctamente"
          this.snackbar = true
        })
        .catch(error => {
          console.error(error.response || error)

          this.color = "red"
          this.icon = "mdi-alert"
          this.error = "Error al eliminar el rubro"
          this.snackbar = true
        })
    },
    obtenerNombreRubro(id) {
      console.log(this.rubro_tipo_ss)
      const rubro = this.rubro_tipo_ss.find(r => r.id === id);
      return rubro ? rubro.nombrecategoria : '';
    },
    resetForm (form) {
      Object.keys(form).forEach(key => {
        if (typeof form[key] === 'boolean') {
          form[key] = false
        } else {
          form[key] = null
        }
      })
    },
    guardarFlota () {
      this.lista_flota.push({ ...this.flota })
      this.resetFlota()
      this.dialogFlota = false
    },

    eliminarFlota (index) {
      this.lista_flota.splice(index, 1)
    },

    resetFlota () {
      Object.keys(this.flota).forEach(k => {
        this.flota[k] = typeof this.flota[k] === 'boolean' ? false : ''
      })
      this.flota.anio = null
    },
    guardarMaquinaria () {
      if (this.indexMaquinariaEdit !== null) {
        this.lista_maquinaria.splice(
          this.indexMaquinariaEdit,
          1,
          { ...this.maquinaria }
        )
        this.indexMaquinariaEdit = null
      } else {
        this.lista_maquinaria.push({ ...this.maquinaria })
      }

      this.resetMaquinaria()
      this.dialogMaquinaria = false
    },

    editarMaquinaria (item, index) {
      this.maquinaria = { ...item }
      this.indexMaquinariaEdit = index
      this.dialogMaquinaria = true
    },

    eliminarMaquinaria (index) {
      this.lista_maquinaria.splice(index, 1)
    },

    guardarPlantagrifo () {
      if (this.indexPlantagrifoEdit !== null) {
        this.lista_plantagrifo.splice(
          this.indexPlantagrifoEdit,
          1,
          { ...this.plantagrifo }
        )
        this.indexPlantagrifoEdit = null
      } else {
        this.lista_plantagrifo.push({ ...this.plantagrifo })
      }

      this.resetPlantagrifo()
      this.dialogPlantagrifo = false
    },

    editarPlantagrifo (item, index) {
      this.plantagrifo = { ...item }
      this.indexPlantagrifoEdit = index
      this.dialogPlantagrifo = true
    },

    resetPlantagrifo () {
      this.plantagrifo = {
        tipo_suministro: "",
        enlace: "",
        producto: "",
        descripcion: "",
        especificacion: "",
        capacidad_almacenamiento: null,
        distritos_cobertura: "",
        capacidadsuministrodiario: null,
        capacidadcisternas: null,
        permisososinergminvigentes: false,
        tiempominimopreaviso: null,
        tarifareferencial: null
      }

      this.indexPlantagrifoEdit = null
    },
    mostrarotrosbienes (idempresa) {
      return axios.get(`/api/OtrosBienes/Listar/${idempresa}`)
      .then(response => {
        // Asegurarse de que las propiedades existen
        // this.cocinaplanta = { ...this.cocinaplanta, ...response.data };
        this.lista_otrosbienes = response.data || [];
        this.tieneOtrosBienes = this.lista_otrosbienes.length > 0;
        console.log(this.tieneOtrosBienes)
      })
      .catch(error => console.error(error));
    },
    guardarOtrosBienes () {
      if (this.indexOtrosBienesEdit !== null) {
        this.lista_otrosbienes.splice(
          this.indexOtrosBienesEdit,
          1,
          { ...this.otrosbienes }
        )
        this.indexOtrosBienesEdit = null
      } else {
        this.lista_otrosbienes.push({ ...this.otrosbienes })
      }

      this.resetOtrosBienes()
      this.dialogOtrosBienes = false
    },

    editarOtrosBienes (item, index) {
      this.otrosbienes = { ...item }
      this.indexOtrosBienesEdit = index
      this.dialogOtrosBienes = true
    },

    resetOtrosBienes () {
      this.otrosbienes = {
        categoria_bien: "",
        descripcion_especifica: "",
        certificacion_producto: "",
        capacidad_suministro_mensual: "",
        ubicacion_almacen: "",
        tiempo_entrega_dias: null,
        bien_propio: false,
        bien_alquilado: false,
        tarifareferencial: null
      }

      this.indexOtrosBienesEdit = null
    },

    resetMaquinaria () {
      this.maquinaria = {
        tipo: '',
        marca_modelo: '',
        anio: null,
        capacidad_tecnica: '',
        certificados_vigentes: false,
        incluye_operador: false,
        incluye_combustible: false,
        tarifa_referencial: ''
      }
    },
    
    /* =========================
       cocina / planta
    ========================== */
    mostrarcocinaplanta (idempresa) {
      return axios.get(`/api/CocinaPlanta/Listar/${idempresa}`)
      .then(response => {
        // Asegurarse de que las propiedades existen
        // this.cocinaplanta = { ...this.cocinaplanta, ...response.data };
        this.lista_cocinaplanta = response.data || [];
        this.tieneAlimentacion = this.lista_cocinaplanta.length > 0;
      })
      .catch(error => console.error(error));
    },
    crearcocinaplanta (data) {
      return axios.post(`/api/CocinaPlanta/Crear`, data)
    },
    actualizarcocinaplanta (id, data) {
      return axios.put(`/api/CocinaPlanta/Actualizar/${id}`, data)
    },
    guardarCocina(){
     this.lista_cocinaplanta.push({...this.cocinaplanta})
     this.dialogCocina=false
     this.cocinaplanta={}
    },

    editarCocina(item,index){
     this.cocinaplanta={...item}
     this.indexCocina=index
     this.dialogCocina=true
    },

    eliminarCocina(index){
     this.lista_cocinaplanta.splice(index,1)
    },

    /* =========================
       hospedaje
    ========================== */
    mostrarhospedaje (idempresa) {
      return axios.get(`/api/Hospedaje/Listar/${idempresa}`)
      .then(response => {
        // Asegurarse de que las propiedades existen
        // this.hospedaje = { ...this.hospedaje, ...response.data };
        this.lista_hospedaje = response.data || [];
        this.tieneAlojamiento = this.lista_hospedaje.length > 0;
      })
      .catch(error => console.error(error));
    },
    crearhospedaje (data) {
      return axios.post(`/api/Hospedaje/Crear`, data)
    },
    actualizarhospedaje (id, data) {
      return axios.put(`/api/Hospedaje/Actualizar/${id}`, data)
    },
    guardarHospedaje(){
     this.lista_hospedaje.push({...this.hospedaje})
     this.dialogHospedaje=false
     this.hospedaje={}
    },

    editarHospedaje(item,index){
     this.hospedaje={...item}
     this.indexHospedaje=index
     this.dialogHospedaje=true
    },

    eliminarHospedaje(index){
     this.lista_hospedaje.splice(index,1)
    },

    /* =========================
       garaje / base operaciones
    ========================== */
    mostrargaraje (idempresa) {
      return axios.get(`/api/GarajeBaseOperaciones/Mostrar/${idempresa}`)
      .then(response => {
        // Asegurarse de que las propiedades existen
        this.garaje = { ...this.garaje, ...response.data };
      })
      .catch(error => console.error(error));
    },
    creargaraje (data) {
      return axios.post(`/api/GarajeBaseOperaciones/Crear`, data)
    },
    actualizargaraje (id, data) {
      return axios.put(`/api/GarajeBaseOperaciones/Actualizar/${id}`, data)
    },

    /* =========================
       flota vehicular
    ========================== */
    mostrarflota (idempresa) {
      return axios.get(`/api/Flota/Listar/${idempresa}`)
      .then(response => {
        // Asegurarse de que las propiedades existen
        // this.flota = { ...this.flota, ...response.data };
        this.lista_flota = response.data || [];
        this.tieneTransporte = this.lista_flota.length > 0;
      })
      .catch(error => console.error(error));
    },
    crearflota (data) {
      return axios.post(`/api/Flota/Crear`, data)
    },
    actualizarflota (id, data) {
      return axios.put(`/api/Flota/Actualizar/${id}`, data)
    },

    /* =========================
       ubicacion equipo
    ========================== */
    mostrarubicacionequipo (idempresa) {
      return axios.get(`/api/UbicacionEquipo/Mostrar/${idempresa}`)
      .then(response => {
        // Asegurarse de que las propiedades existen
        this.ubicacionequipo = { ...this.ubicacionequipo, ...response.data };
      })
      .catch(error => console.error(error));
    },
    crearubicacionequipo (data) {
      return axios.post(`/api/UbicacionEquipo/Crear`, data)
    },
    actualizarubicacionequipo (id, data) {
      return axios.put(`/api/UbicacionEquipo/Actualizar/${id}`, data)
    },

    /* =========================
       maquinaria
    ========================== */
    mostrarmaquinaria (idempresa) {
      return axios.get(`/api/Maquinaria/Listar/${idempresa}`)
      .then(response => {
        // Asegurarse de que las propiedades existen
        // this.maquinaria = { ...this.maquinaria, ...response.data };
        this.lista_maquinaria = response.data || [];
        this.tieneMaquinaria = this.lista_maquinaria.length > 0 ;
      })
      .catch(error => console.error(error));
    },
    crearmaquinaria (data) {
      return axios.post(`/api/Maquinaria/Crear`, data)
    },
    actualizarmaquinaria (id, data) {
      return axios.put(`/api/Maquinaria/Actualizar/${id}`, data)
    },

    /* =========================
       planta / grifo
    ========================== */
    mostrarplantagrifo (idempresa) {
      return axios.get(`/api/PlantaGrifo/Listar/${idempresa}`)
      .then(response => {
        // Asegurarse de que las propiedades existen
        // this.plantagrifo = { ...this.plantagrifo, ...response.data };
        this.lista_plantagrifo = response.data || [];
        this.tieneCombustible = this.lista_plantagrifo.length > 0;
      })
      .catch(error => console.error(error));
    },
    crearplantagrifo (data) {
      return axios.post(`/api/PlantaGrifo/Crear`, data)
    },
    actualizarplantagrifo (id, data) {
      return axios.put(`/api/PlantaGrifo/Actualizar/${id}`, data)
    },

    editarMaquinaria (item, index) {
      this.indexMaquinariaEdit = index
      this.maquinaria = { ...item }
      this.dialogMaquinaria = true
    },
    editarFlota (item, index) {
      this.indexFlotaEdit = index
      this.flota = { ...item }
      this.dialogFlota = true
    },

    eliminarMaquinaria (index) {
      this.lista_maquinaria.splice(index, 1)
    },

    cerrarDialogMaquinaria () {
      this.dialogMaquinaria = false
      this.maquinaria = {}
      this.indexMaquinariaEdit = null
    },
    mostrarotrosservicios (idempresa) {
      return axios.get(`/api/OtrosServicios/Listar/${idempresa}`)
      .then(response => {
        // Asegurarse de que las propiedades existen
        // this.cocinaplanta = { ...this.cocinaplanta, ...response.data };
        this.lista_otrosservicios = response.data || [];
        this.tieneOtrosServicios = this.lista_otrosservicios.length > 0;
      })
      .catch(error => console.error(error));
    },
    guardarOtrosServicios () {
      if (this.indexOtrosServiciosEdit !== null) {
        this.lista_otrosservicios.splice(
          this.indexOtrosServiciosEdit,
          1,
          { ...this.otrosservicios }
        )
        this.indexOtrosServiciosEdit = null
      } else {
        this.lista_otrosservicios.push({ ...this.otrosservicios })
      }

      this.resetOtrosServicios()
      this.dialogOtrosServicios = false
    },

    editarOtrosServicios (item, index) {
      this.otrosservicios = { ...item }
      this.indexOtrosServiciosEdit = index
      this.dialogOtrosServicios = true
    },

    resetOtrosServicios () {
      this.otrosservicios = {
        categoria_servicio: "",
        descripcion_servicio: "",
        equipamiento_propio: false,
        personal_especializado: false,
        atiende_campamento: false,
        tiempo_respuesta: "",
        certificaciones: "",
        experiencia_relevante: "",
        tarifareferencial: null
      }

      this.indexOtrosServiciosEdit = null
    },

    /* =========================
       PLANTA / GRIFO
    ========================== */
    cargarPlantaGrifo () {
      proveedoresService.mostrar_plantagrifo(this.idempresa)
        .then(r => {
          this.plantagrifo = r.data || {}
        })
    },

    guardarPlantaGrifo () {
      if (this.indexPlantaGrifoEdit === null) {
        this.plantagrifo.idempresa = this.idempresa

        proveedoresService.crear_plantagrifo(this.plantagrifo)
          .then(() => this.cargarPlantaGrifo())
      } else {
        proveedoresService.actualizar_plantagrifo(
          this.plantagrifo.idplantagrifo,
          this.plantagrifo
        ).then(() => this.cargarPlantaGrifo())
      }
    },
    async upsertModulo ({ mostrar, crear, actualizar, data, idField }) {
      try {

        if (res.data && res.data[idField]) {
          await actualizar(res.data[idField], {
            ...data,
            idempresa: this.idempresa
          })
        } else {
          await crear({
            ...data,
            idempresa: this.idempresa
          })
        }
        const res = await mostrar(this.idempresa)
      } catch (e) {
        // si no existe → crear
        await crear({
          ...data,
          idempresa: this.idempresa
        })
      }
    },
    async saveRubrosEspeciales () {
      const tareas = []

      if (this.tieneAlimentacion) {
        tareas.push(
          this.upsertModulo({
            mostrar: this.mostrarcocinaplanta,
            crear: this.crearcocinaplanta,
            actualizar: this.actualizarcocinaplanta,
            data: this.cocinaplanta,
            idField: 'idcocinaplanta'
          })
        )
      }

      if (this.tieneAlojamiento) {
        tareas.push(
          this.upsertModulo({
            mostrar: this.mostrarhospedaje,
            crear: this.crearhospedaje,
            actualizar: this.actualizarhospedaje,
            data: this.hospedaje,
            idField: 'idhospedaje'
          })
        )
      }

      if (this.tieneTransporte) {
        this.garaje.fecharegistro = new Date().toISOString().slice(0, 10)
        tareas.push(
          this.upsertModulo({
            crear: this.creargaraje,
            actualizar: this.actualizargaraje,
            mostrar: this.mostrargaraje,
            data: this.garaje,
            idField: 'idgaraje'
          })
        )
        tareas.push(
          this.upsertModulo({
            crear: this.crearflota,
            actualizar: this.actualizarflota,
            mostrar: this.mostrarflota,
            data: this.garaje,
            idField: 'idflota'
          })
        )
      }

      if (this.tieneMaquinaria) {
        tareas.push(
          this.upsertModulo({
            mostrar: this.mostrarmaquinaria,
            crear: this.crearmaquinaria,
            actualizar: this.actualizarmaquinaria,
            data: {
              ...this.maquinaria,
              lista_maquinaria: this.lista_maquinaria
            },
            idField: 'idmaquinaria'
          })
        )
      }

      if (this.tieneCombustible) {
        tareas.push(
          this.upsertModulo({
            mostrar: this.mostrarplantagrifo,
            crear: this.crearplantagrifo,
            actualizar: this.actualizarplantagrifo,
            data: this.plantagrifo,
            idField: 'idplantagrifo'
          })
        )
      }

      await Promise.all(tareas)
    },
    seleccionarArchivo(e) {
      this.archivo = e.target.files[0];
    },
    async importarExcel() {
      if (!this.archivo) {
        alert("Seleccione un archivo");
        return;
      }

      const formData = new FormData();
      formData.append("archivo", this.archivo);

      this.loading = true;

      try {
        await axios.post("/api/Empresas/importar-excel", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        alert("Importación exitosa");
      } catch (error) {
        console.error(error);
        alert("Error al importar");
      } finally {
        this.loading = false;
      }
    },
    generarFechaInicio1() {
      if (this.isDate(this.fecha_presentacion)) {
        var d = new Date(this.fecha_presentacion + "T00:00:00");
        d.setDate(d.getDate() + 1);
      }
    },
    generarFechaInicio2() {
      if (this.isDate(this.fecha_emi_dni)) {
        var d = new Date(this.fecha_emi_dni + "T00:00:00");
        d.setDate(d.getDate() + 1);
      }
    },
    generarFechaInicio3() {
      if (this.isDate(this.fecha_inicio_ruc)) {
        var d = new Date(this.fecha_inicio_ruc + "T00:00:00");
        d.setDate(d.getDate() + 1);
      }
    },
    async subirExcel(file) {
      const formData = new FormData()
      formData.append('file', file)

      try {
        await axios.post(
          '/api/Empresas/ImportarServicios',
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )

        // ✅ Éxito
        this.color = '#2A3B4D'
        this.icon = 'mdi-thumb-up'
        this.error = 'Archivo importado correctamente'
        this.snackbar = true
      } catch (e) {
        console.error(e)

        const msg =
          e.response?.data ||
          'Error al importar archivo'

        // ❌ Error
        this.color = '#E53935'
        this.icon = 'mdi-alert'
        this.error = msg
        this.snackbar = true
      }
    },
  },
  watch: {
    fecha_inicio_ruc(newValue) {
      this.puntaje_antiguedad = this.calcularPuntajeAntiguedad(newValue);
    },
    async ubigeo_nacimiento(newValue) {
      if (!newValue || newValue.length !== 6) {
        this.lugar_nacimiento = "";
        return;
      }

      try {
        const response = await axios.get(`/api/Ubig/GetUbigeo/?idubigeo=${newValue}`);
        const data = response.data;
        if (Array.isArray(data) && data.length > 0) {
          this.lugar_nacimiento = data[0].distrito;
          this.influencia_dni = this.getAreaInfluencia(data[0].distrito);
        } else {
          this.lugar_nacimiento = "";
        }
      } catch (error) {
        console.error(error);
        this.lugar_nacimiento = "";
      }
    },
    residencia(newValue) {
      if (!newValue) {
        this.influencia_residencia = "";
        return;
      }

      const val = newValue.trim().toLowerCase();

      const AID = ["cocachacra", "dean valdivia", "mejia"];
      const AII = ["punta de bombon", "mollendo", "islay"];

      if (AID.includes(val)) {
        this.influencia_residencia = "AID";
      } 
      else if (AII.includes(val)) {
        this.influencia_residencia = "AII";
      } 
      else {
        this.influencia_residencia = "Foránea";
      }
    },
    fecha_emi_dni(newValue) {
      this.puntaje_residencia = this.calcularPuntaje(newValue);
    },
    influencia_residencia(newValue) {
      this.localia_representante = this.calcularLocalidad(newValue, this.influencia_dni);
      this.calcularPuntajeLocalia();
      this.actualizarResidenciaFinal();
      this.actualizarTotalLocalia();
    },
    influencia_dni(newValue) {
      this.localia_representante = this.calcularLocalidad(this.influencia_residencia, newValue);
      this.calcularPuntajeLocalia();
      this.actualizarResidenciaFinal();
    },
    porcentaje_pro() { this.calcularPuntajeLocalia(); },
    distrito(newValue) {
      this.domicilio_fiscal = newValue;
    },
    domicilio_fiscal(newValue) {
      this.area_influencia_ruc = this.calcularInfluencia(newValue);
    },
    area_influencia_ruc(newVal) {
      this.puntaje_localia_dom = this.calcularPuntajeLocaliaPorDomicilioFiscal(newVal);
      this.actualizarResidenciaFinal();
    },
    puntaje_localia() { this.actualizarTotalLocalia(); },
    puntaje_antiguedad() { this.actualizarTotalLocalia(); },
    puntaje_localia_dom() { this.actualizarTotalLocalia(); },
    puntaje_residencia() { this.actualizarTotalLocalia(); },
    comentario(newVal) {
      this.empresa_foranea = this.calcularEmpresaForanea(newVal);
    },
    puntaje_total_localia() { this.calcularCategoriaProveedor(); },
    empresa_foranea() { this.calcularCategoriaProveedor(); },
    rubro_tipo_servicio () {
      this.resetForm(this.cocinaplanta)
      this.resetForm(this.hospedaje)
      this.resetForm(this.garaje)
      this.resetForm(this.flota)
      this.resetForm(this.ubicacionequipo)
      this.resetForm(this.maquinaria)
      this.resetForm(this.plantagrifo)
    }
  }
};
</script>
<style scoped>
* {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 300;
}
.my-input {
  text-transform: uppercase;
}
.v-application .primary {
    background-color: #2D8C9E !important;
    border-color: #2D8C9E !important;
}
.v-application .primary--text {
    color: #2D8C9E !important;
    caret-color: #2D8C9E !important;
}
</style>